//百度地图中国城市经纬度
export let cityList = [
    {
        "city_name": "北京市",
        "city_code": "110100",
        "province_name": "北京市",
        "province_code": "110000",
        "city_lng": 116.395645,
        "city_lat": 39.92998578
    },
    {
        "city_name": "天津市",
        "city_code": "120100",
        "province_name": "天津市",
        "province_code": "120000",
        "city_lng": 117.236835,
        "city_lat": 38.951618
    },
    {
        "city_name": "石家庄市",
        "city_code": "130100",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 114.508749,
        "city_lat": 38.041707
    },
    {
        "city_name": "唐山市",
        "city_code": "130200",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 118.174281,
        "city_lat": 39.629155
    },
    {
        "city_name": "秦皇岛市",
        "city_code": "130300",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 119.594878,
        "city_lat": 39.934313
    },
    {
        "city_name": "邯郸市",
        "city_code": "130400",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 114.487466,
        "city_lat": 36.61196
    },
    {
        "city_name": "邢台市",
        "city_code": "130500",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 114.498874,
        "city_lat": 37.07015
    },
    {
        "city_name": "保定市",
        "city_code": "130600",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 115.458247,
        "city_lat": 38.873039
    },
    {
        "city_name": "张家口市",
        "city_code": "130700",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 114.881418,
        "city_lat": 40.823098
    },
    {
        "city_name": "承德市",
        "city_code": "130800",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 117.937596,
        "city_lat": 40.976633
    },
    {
        "city_name": "沧州市",
        "city_code": "130900",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 116.832886,
        "city_lat": 38.303841
    },
    {
        "city_name": "廊坊市",
        "city_code": "131000",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 116.700575,
        "city_lat": 39.519637
    },
    {
        "city_name": "衡水市",
        "city_code": "131100",
        "province_name": "河北省",
        "province_code": "130000",
        "city_lng": 115.664657,
        "city_lat": 37.738223
    },
    {
        "city_name": "太原市",
        "city_code": "140100",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 112.544344,
        "city_lat": 37.870043
    },
    {
        "city_name": "大同市",
        "city_code": "140200",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 113.292995,
        "city_lat": 40.075171
    },
    {
        "city_name": "阳泉市",
        "city_code": "140300",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 113.574052,
        "city_lat": 37.856163
    },
    {
        "city_name": "长治市",
        "city_code": "140400",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 113.111295,
        "city_lat": 36.195124
    },
    {
        "city_name": "晋城市",
        "city_code": "140500",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 112.84563,
        "city_lat": 35.491221
    },
    {
        "city_name": "朔州市",
        "city_code": "140600",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 112.425988,
        "city_lat": 39.330369
    },
    {
        "city_name": "晋中市",
        "city_code": "140700",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 112.746255,
        "city_lat": 37.686327
    },
    {
        "city_name": "运城市",
        "city_code": "140800",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 111.001197,
        "city_lat": 35.027031
    },
    {
        "city_name": "忻州市",
        "city_code": "140900",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 112.727607,
        "city_lat": 38.416106
    },
    {
        "city_name": "临汾市",
        "city_code": "141000",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 111.512729,
        "city_lat": 36.088045
    },
    {
        "city_name": "吕梁市",
        "city_code": "141100",
        "province_name": "山西省",
        "province_code": "140000",
        "city_lng": 111.13778,
        "city_lat": 37.519059
    },
    {
        "city_name": "呼和浩特市",
        "city_code": "150100",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 111.743362,
        "city_lat": 40.840342
    },
    {
        "city_name": "包头市",
        "city_code": "150200",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 109.834529,
        "city_lat": 40.656201
    },
    {
        "city_name": "乌海市",
        "city_code": "150300",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 106.78941,
        "city_lat": 39.653703
    },
    {
        "city_name": "赤峰市",
        "city_code": "150400",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 118.882945,
        "city_lat": 42.256408
    },
    {
        "city_name": "通辽市",
        "city_code": "150500",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 122.260201,
        "city_lat": 43.617048
    },
    {
        "city_name": "鄂尔多斯市",
        "city_code": "150600",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 109.775518,
        "city_lat": 39.60732
    },
    {
        "city_name": "呼伦贝尔市",
        "city_code": "150700",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 119.758472,
        "city_lat": 49.209678
    },
    {
        "city_name": "巴彦淖尔市",
        "city_code": "150800",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 107.38213,
        "city_lat": 40.74171
    },
    {
        "city_name": "乌兰察布市",
        "city_code": "150900",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 113.126524,
        "city_lat": 40.992392
    },
    {
        "city_name": "兴安盟",
        "city_code": "152200",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 122.0481665,
        "city_lat": 46.08375707
    },
    {
        "city_name": "锡林郭勒盟",
        "city_code": "152500",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 116.0273397,
        "city_lat": 43.93970484
    },
    {
        "city_name": "阿拉善盟",
        "city_code": "152900",
        "province_name": "内蒙古自治区",
        "province_code": "150000",
        "city_lng": 105.845418,
        "city_lat": 38.925909
    },
    {
        "city_name": "沈阳市",
        "city_code": "210100",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 123.426215,
        "city_lat": 41.803194
    },
    {
        "city_name": "大连市",
        "city_code": "210200",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 121.609814,
        "city_lat": 38.912912
    },
    {
        "city_name": "鞍山市",
        "city_code": "210300",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 122.989449,
        "city_lat": 41.106615
    },
    {
        "city_name": "抚顺市",
        "city_code": "210400",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 123.951844,
        "city_lat": 41.87853
    },
    {
        "city_name": "本溪市",
        "city_code": "210500",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 123.760969,
        "city_lat": 41.29203
    },
    {
        "city_name": "丹东市",
        "city_code": "210600",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 124.379254,
        "city_lat": 40.125408
    },
    {
        "city_name": "锦州市",
        "city_code": "210700",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 121.121384,
        "city_lat": 41.093093
    },
    {
        "city_name": "营口市",
        "city_code": "210800",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 122.229725,
        "city_lat": 40.665256
    },
    {
        "city_name": "阜新市",
        "city_code": "210900",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 121.664713,
        "city_lat": 42.01956
    },
    {
        "city_name": "辽阳市",
        "city_code": "211000",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 123.167769,
        "city_lat": 41.267333
    },
    {
        "city_name": "盘锦市",
        "city_code": "211100",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 122.06529,
        "city_lat": 41.117875
    },
    {
        "city_name": "铁岭市",
        "city_code": "211200",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 123.719977,
        "city_lat": 42.221236
    },
    {
        "city_name": "朝阳市",
        "city_code": "211300",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 120.445096,
        "city_lat": 41.571164
    },
    {
        "city_name": "葫芦岛市",
        "city_code": "211400",
        "province_name": "辽宁省",
        "province_code": "210000",
        "city_lng": 120.831807,
        "city_lat": 40.709536
    },
    {
        "city_name": "长春市",
        "city_code": "220100",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 125.317071,
        "city_lat": 43.813716
    },
    {
        "city_name": "吉林市",
        "city_code": "220200",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 126.543727,
        "city_lat": 43.835562
    },
    {
        "city_name": "四平市",
        "city_code": "220300",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 124.344161,
        "city_lat": 43.163893
    },
    {
        "city_name": "辽源市",
        "city_code": "220400",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 125.137268,
        "city_lat": 42.885512
    },
    {
        "city_name": "通化市",
        "city_code": "220500",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 125.934252,
        "city_lat": 41.72613
    },
    {
        "city_name": "白山市",
        "city_code": "220600",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 126.417824,
        "city_lat": 41.937753
    },
    {
        "city_name": "松原市",
        "city_code": "220700",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 124.81851,
        "city_lat": 45.139422
    },
    {
        "city_name": "白城市",
        "city_code": "220800",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 122.832828,
        "city_lat": 45.617675
    },
    {
        "city_name": "延边朝鲜族自治州",
        "city_code": "222400",
        "province_name": "吉林省",
        "province_code": "220000",
        "city_lng": 129.485902,
        "city_lat": 42.8964136
    },
    {
        "city_name": "哈尔滨市",
        "city_code": "230100",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 126.529063,
        "city_lat": 45.801361
    },
    {
        "city_name": "齐齐哈尔市",
        "city_code": "230200",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 123.911409,
        "city_lat": 47.352275
    },
    {
        "city_name": "鸡西市",
        "city_code": "230300",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 130.962106,
        "city_lat": 45.293091
    },
    {
        "city_name": "鹤岗市",
        "city_code": "230400",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 130.290158,
        "city_lat": 47.347482
    },
    {
        "city_name": "双鸭山市",
        "city_code": "230500",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 131.150968,
        "city_lat": 46.644331
    },
    {
        "city_name": "大庆市",
        "city_code": "230600",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 125.097317,
        "city_lat": 46.58765
    },
    {
        "city_name": "伊春市",
        "city_code": "230700",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 128.833425,
        "city_lat": 47.725237
    },
    {
        "city_name": "佳木斯市",
        "city_code": "230800",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 130.31269,
        "city_lat": 46.797399
    },
    {
        "city_name": "七台河市",
        "city_code": "230900",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 130.995391,
        "city_lat": 45.768448
    },
    {
        "city_name": "牡丹江市",
        "city_code": "231000",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 129.625374,
        "city_lat": 44.550722
    },
    {
        "city_name": "黑河市",
        "city_code": "231100",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 127.52121,
        "city_lat": 50.243585
    },
    {
        "city_name": "绥化市",
        "city_code": "231200",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 126.962299,
        "city_lat": 46.652007
    },
    {
        "city_name": "大兴安岭地区",
        "city_code": "232700",
        "province_name": "黑龙江省",
        "province_code": "230000",
        "city_lng": 123.956896,
        "city_lat": 52.410552
    },
    {
        "city_name": "上海市",
        "city_code": "310100",
        "province_name": "上海市",
        "province_code": "310000",
        "city_lng": 121.373237,
        "city_lat": 31.273094
    },
    {
        "city_name": "南京市",
        "city_code": "320100",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 118.791277,
        "city_lat": 32.060447
    },
    {
        "city_name": "无锡市",
        "city_code": "320200",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 120.307736,
        "city_lat": 31.493195
    },
    {
        "city_name": "徐州市",
        "city_code": "320300",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 117.280019,
        "city_lat": 34.205689
    },
    {
        "city_name": "常州市",
        "city_code": "320400",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 119.969289,
        "city_lat": 31.812037
    },
    {
        "city_name": "苏州市",
        "city_code": "320500",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 120.581256,
        "city_lat": 31.300996
    },
    {
        "city_name": "南通市",
        "city_code": "320600",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 120.890069,
        "city_lat": 31.982945
    },
    {
        "city_name": "连云港市",
        "city_code": "320700",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 119.21607,
        "city_lat": 34.597765
    },
    {
        "city_name": "淮安市",
        "city_code": "320800",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 119.010114,
        "city_lat": 33.611678
    },
    {
        "city_name": "盐城市",
        "city_code": "320900",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 120.156672,
        "city_lat": 33.350937
    },
    {
        "city_name": "扬州市",
        "city_code": "321000",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 119.407972,
        "city_lat": 32.395643
    },
    {
        "city_name": "镇江市",
        "city_code": "321100",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 119.451424,
        "city_lat": 32.202181
    },
    {
        "city_name": "泰州市",
        "city_code": "321200",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 119.918325,
        "city_lat": 32.45713
    },
    {
        "city_name": "宿迁市",
        "city_code": "321300",
        "province_name": "江苏省",
        "province_code": "320000",
        "city_lng": 118.269989,
        "city_lat": 33.963285
    },
    {
        "city_name": "杭州市",
        "city_code": "330100",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 120.2042181,
        "city_lat": 30.24775551
    },
    {
        "city_name": "宁波市",
        "city_code": "330200",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 121.546103,
        "city_lat": 29.876429
    },
    {
        "city_name": "温州市",
        "city_code": "330300",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 120.695336,
        "city_lat": 27.998204
    },
    {
        "city_name": "嘉兴市",
        "city_code": "330400",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 120.75119,
        "city_lat": 30.748283
    },
    {
        "city_name": "湖州市",
        "city_code": "330500",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 120.081895,
        "city_lat": 30.896321
    },
    {
        "city_name": "绍兴市",
        "city_code": "330600",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 120.575672,
        "city_lat": 30.03282
    },
    {
        "city_name": "金华市",
        "city_code": "330700",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 119.642882,
        "city_lat": 29.081101
    },
    {
        "city_name": "衢州市",
        "city_code": "330800",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 118.869402,
        "city_lat": 28.939038
    },
    {
        "city_name": "舟山市",
        "city_code": "330900",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 122.203617,
        "city_lat": 29.987783
    },
    {
        "city_name": "台州市",
        "city_code": "331000",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 121.41632,
        "city_lat": 28.659098
    },
    {
        "city_name": "丽水市",
        "city_code": "331100",
        "province_name": "浙江省",
        "province_code": "330000",
        "city_lng": 119.918523,
        "city_lat": 28.470607
    },
    {
        "city_name": "合肥市",
        "city_code": "340100",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 117.222316,
        "city_lat": 31.822454
    },
    {
        "city_name": "芜湖市",
        "city_code": "340200",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 118.427814,
        "city_lat": 31.354007
    },
    {
        "city_name": "蚌埠市",
        "city_code": "340300",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 117.383474,
        "city_lat": 32.91719
    },
    {
        "city_name": "淮南市",
        "city_code": "340400",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 116.994373,
        "city_lat": 32.62761
    },
    {
        "city_name": "马鞍山市",
        "city_code": "340500",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 118.501342,
        "city_lat": 31.672442
    },
    {
        "city_name": "淮北市",
        "city_code": "340600",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 116.792934,
        "city_lat": 33.956212
    },
    {
        "city_name": "铜陵市",
        "city_code": "340700",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 117.806045,
        "city_lat": 30.969275
    },
    {
        "city_name": "安庆市",
        "city_code": "340800",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 117.051814,
        "city_lat": 30.527175
    },
    {
        "city_name": "黄山市",
        "city_code": "341000",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 118.333864,
        "city_lat": 29.717773
    },
    {
        "city_name": "滁州市",
        "city_code": "341100",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 118.311433,
        "city_lat": 32.303822
    },
    {
        "city_name": "阜阳市",
        "city_code": "341200",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 115.808725,
        "city_lat": 32.891924
    },
    {
        "city_name": "宿州市",
        "city_code": "341300",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 116.958546,
        "city_lat": 33.64772
    },
    {
        "city_name": "六安市",
        "city_code": "341500",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 116.514612,
        "city_lat": 31.736829
    },
    {
        "city_name": "亳州市",
        "city_code": "341600",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 115.773189,
        "city_lat": 33.845866
    },
    {
        "city_name": "池州市",
        "city_code": "341700",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 117.485932,
        "city_lat": 30.667034
    },
    {
        "city_name": "宣城市",
        "city_code": "341800",
        "province_name": "安徽省",
        "province_code": "340000",
        "city_lng": 118.753529,
        "city_lat": 30.942991
    },
    {
        "city_name": "福州市",
        "city_code": "350100",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 119.291793,
        "city_lat": 26.07713
    },
    {
        "city_name": "厦门市",
        "city_code": "350200",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 118.084498,
        "city_lat": 24.482158
    },
    {
        "city_name": "莆田市",
        "city_code": "350300",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 119.002989,
        "city_lat": 25.456799
    },
    {
        "city_name": "三明市",
        "city_code": "350400",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 117.634308,
        "city_lat": 26.267237
    },
    {
        "city_name": "泉州市",
        "city_code": "350500",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 118.582642,
        "city_lat": 24.910435
    },
    {
        "city_name": "漳州市",
        "city_code": "350600",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 117.642473,
        "city_lat": 24.51646
    },
    {
        "city_name": "南平市",
        "city_code": "350700",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 118.172827,
        "city_lat": 26.64481
    },
    {
        "city_name": "龙岩市",
        "city_code": "350800",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 117.012361,
        "city_lat": 25.077812
    },
    {
        "city_name": "宁德市",
        "city_code": "350900",
        "province_name": "福建省",
        "province_code": "350000",
        "city_lng": 119.521048,
        "city_lat": 26.669976
    },
    {
        "city_name": "南昌市",
        "city_code": "360100",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 115.853241,
        "city_lat": 28.685801
    },
    {
        "city_name": "景德镇市",
        "city_code": "360200",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 117.17306,
        "city_lat": 29.271323
    },
    {
        "city_name": "萍乡市",
        "city_code": "360300",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 113.849129,
        "city_lat": 27.626075
    },
    {
        "city_name": "九江市",
        "city_code": "360400",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 115.99638,
        "city_lat": 29.70803
    },
    {
        "city_name": "新余市",
        "city_code": "360500",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 114.912285,
        "city_lat": 27.821222
    },
    {
        "city_name": "鹰潭市",
        "city_code": "360600",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 117.063918,
        "city_lat": 28.263322
    },
    {
        "city_name": "赣州市",
        "city_code": "360700",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 114.930032,
        "city_lat": 25.834275
    },
    {
        "city_name": "吉安市",
        "city_code": "360800",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 114.988786,
        "city_lat": 27.117183
    },
    {
        "city_name": "宜春市",
        "city_code": "360900",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 114.410819,
        "city_lat": 27.817976
    },
    {
        "city_name": "抚州市",
        "city_code": "361000",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 116.352948,
        "city_lat": 27.952434
    },
    {
        "city_name": "上饶市",
        "city_code": "361100",
        "province_name": "江西省",
        "province_code": "360000",
        "city_lng": 117.938593,
        "city_lat": 28.45804
    },
    {
        "city_name": "济南市",
        "city_code": "370100",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 116.989128,
        "city_lat": 36.665054
    },
    {
        "city_name": "青岛市",
        "city_code": "370200",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 120.377854,
        "city_lat": 36.06596
    },
    {
        "city_name": "淄博市",
        "city_code": "370300",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 118.048728,
        "city_lat": 36.812581
    },
    {
        "city_name": "枣庄市",
        "city_code": "370400",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 117.317717,
        "city_lat": 34.810898
    },
    {
        "city_name": "东营市",
        "city_code": "370500",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 118.669005,
        "city_lat": 37.432983
    },
    {
        "city_name": "烟台市",
        "city_code": "370600",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 121.442467,
        "city_lat": 37.4626
    },
    {
        "city_name": "潍坊市",
        "city_code": "370700",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 119.155861,
        "city_lat": 36.706402
    },
    {
        "city_name": "济宁市",
        "city_code": "370800",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 116.581941,
        "city_lat": 35.415036
    },
    {
        "city_name": "泰安市",
        "city_code": "370900",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 117.08234,
        "city_lat": 36.199686
    },
    {
        "city_name": "威海市",
        "city_code": "371000",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 122.116557,
        "city_lat": 37.5125
    },
    {
        "city_name": "日照市",
        "city_code": "371100",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 119.521743,
        "city_lat": 35.416736
    },
    {
        "city_name": "临沂市",
        "city_code": "371300",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 118.350711,
        "city_lat": 35.105049
    },
    {
        "city_name": "德州市",
        "city_code": "371400",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 116.353374,
        "city_lat": 37.434634
    },
    {
        "city_name": "聊城市",
        "city_code": "371500",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 115.979634,
        "city_lat": 36.456946
    },
    {
        "city_name": "滨州市",
        "city_code": "371600",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 117.964858,
        "city_lat": 37.381227
    },
    {
        "city_name": "菏泽市",
        "city_code": "371700",
        "province_name": "山东省",
        "province_code": "370000",
        "city_lng": 115.474779,
        "city_lat": 35.233925
    },
    {
        "city_name": "郑州市",
        "city_code": "410100",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 113.619301,
        "city_lat": 34.748374
    },
    {
        "city_name": "开封市",
        "city_code": "410200",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 114.301476,
        "city_lat": 34.798163
    },
    {
        "city_name": "洛阳市",
        "city_code": "410300",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 112.447336,
        "city_lat": 34.619127
    },
    {
        "city_name": "平顶山市",
        "city_code": "410400",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 113.186303,
        "city_lat": 33.767782
    },
    {
        "city_name": "安阳市",
        "city_code": "410500",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 114.387013,
        "city_lat": 36.09754
    },
    {
        "city_name": "鹤壁市",
        "city_code": "410600",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 114.291356,
        "city_lat": 35.749956
    },
    {
        "city_name": "新乡市",
        "city_code": "410700",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 113.921019,
        "city_lat": 35.30313
    },
    {
        "city_name": "焦作市",
        "city_code": "410800",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 113.235636,
        "city_lat": 35.216137
    },
    {
        "city_name": "濮阳市",
        "city_code": "410900",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 115.023445,
        "city_lat": 35.761908
    },
    {
        "city_name": "许昌市",
        "city_code": "411000",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 113.846436,
        "city_lat": 34.037242
    },
    {
        "city_name": "漯河市",
        "city_code": "411100",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 114.010901,
        "city_lat": 33.582992
    },
    {
        "city_name": "三门峡市",
        "city_code": "411200",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 111.194289,
        "city_lat": 34.773576
    },
    {
        "city_name": "南阳市",
        "city_code": "411300",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 112.522644,
        "city_lat": 32.99289
    },
    {
        "city_name": "商丘市",
        "city_code": "411400",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 115.650846,
        "city_lat": 34.415643
    },
    {
        "city_name": "信阳市",
        "city_code": "411500",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 114.062796,
        "city_lat": 32.125089
    },
    {
        "city_name": "周口市",
        "city_code": "411600",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 114.652273,
        "city_lat": 33.619985
    },
    {
        "city_name": "驻马店市",
        "city_code": "411700",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 114.016614,
        "city_lat": 33.013595
    },
    {
        "city_name": "济源市",
        "city_code": "419001",
        "province_name": "河南省",
        "province_code": "410000",
        "city_lng": 112.590047,
        "city_lat": 35.090378
    },
    {
        "city_name": "武汉市",
        "city_code": "420100",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 114.299815,
        "city_lat": 30.595174
    },
    {
        "city_name": "黄石市",
        "city_code": "420200",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 115.033522,
        "city_lat": 30.201963
    },
    {
        "city_name": "十堰市",
        "city_code": "420300",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 110.79268,
        "city_lat": 32.631353
    },
    {
        "city_name": "宜昌市",
        "city_code": "420500",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 111.280766,
        "city_lat": 30.694303
    },
    {
        "city_name": "襄阳市",
        "city_code": "420600",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 112.13916,
        "city_lat": 32.049221
    },
    {
        "city_name": "鄂州市",
        "city_code": "420700",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 114.889904,
        "city_lat": 30.393539
    },
    {
        "city_name": "荆门市",
        "city_code": "420800",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 112.19361,
        "city_lat": 31.037658
    },
    {
        "city_name": "孝感市",
        "city_code": "420900",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 113.910962,
        "city_lat": 30.92731
    },
    {
        "city_name": "荆州市",
        "city_code": "421000",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 112.233744,
        "city_lat": 30.337504
    },
    {
        "city_name": "黄冈市",
        "city_code": "421100",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 114.867307,
        "city_lat": 30.456132
    },
    {
        "city_name": "咸宁市",
        "city_code": "421200",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 114.317049,
        "city_lat": 29.843735
    },
    {
        "city_name": "随州市",
        "city_code": "421300",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 113.376237,
        "city_lat": 31.692129
    },
    {
        "city_name": "恩施土家族苗族自治州",
        "city_code": "422800",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 109.483271,
        "city_lat": 30.155278
    },
    {
        "city_name": "仙桃市",
        "city_code": "429004",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 113.453974,
        "city_lat": 30.364953
    },
    {
        "city_name": "潜江市",
        "city_code": "429005",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 112.896866,
        "city_lat": 30.421215
    },
    {
        "city_name": "天门市",
        "city_code": "429006",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 113.165862,
        "city_lat": 30.653061
    },
    {
        "city_name": "神农架林区",
        "city_code": "429021",
        "province_name": "湖北省",
        "province_code": "420000",
        "city_lng": 110.671525,
        "city_lat": 31.744449
    },
    {
        "city_name": "长沙市",
        "city_code": "430100",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 112.933419,
        "city_lat": 28.23129
    },
    {
        "city_name": "株洲市",
        "city_code": "430200",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 113.128117,
        "city_lat": 27.830799
    },
    {
        "city_name": "湘潭市",
        "city_code": "430300",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 112.93869,
        "city_lat": 27.833205
    },
    {
        "city_name": "衡阳市",
        "city_code": "430400",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 112.566708,
        "city_lat": 26.896812
    },
    {
        "city_name": "邵阳市",
        "city_code": "430500",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 111.46212,
        "city_lat": 27.242131
    },
    {
        "city_name": "岳阳市",
        "city_code": "430600",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 113.122711,
        "city_lat": 29.359596
    },
    {
        "city_name": "常德市",
        "city_code": "430700",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 111.692942,
        "city_lat": 29.034608
    },
    {
        "city_name": "张家界市",
        "city_code": "430800",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 110.474187,
        "city_lat": 29.119129
    },
    {
        "city_name": "益阳市",
        "city_code": "430900",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 112.349514,
        "city_lat": 28.557358
    },
    {
        "city_name": "郴州市",
        "city_code": "431000",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 113.009153,
        "city_lat": 25.77358
    },
    {
        "city_name": "永州市",
        "city_code": "431100",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 111.607015,
        "city_lat": 26.423934
    },
    {
        "city_name": "怀化市",
        "city_code": "431200",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 109.993174,
        "city_lat": 27.559867
    },
    {
        "city_name": "娄底市",
        "city_code": "431300",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 111.98908,
        "city_lat": 27.700606
    },
    {
        "city_name": "湘西土家族苗族自治州",
        "city_code": "433100",
        "province_name": "湖南省",
        "province_code": "430000",
        "city_lng": 109.722187,
        "city_lat": 28.748219
    },
    {
        "city_name": "广州市",
        "city_code": "440100",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 113.259987,
        "city_lat": 23.131407
    },
    {
        "city_name": "韶关市",
        "city_code": "440200",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 113.592051,
        "city_lat": 24.813318
    },
    {
        "city_name": "深圳市",
        "city_code": "440300",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 114.052857,
        "city_lat": 22.545676
    },
    {
        "city_name": "珠海市",
        "city_code": "440400",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 113.571631,
        "city_lat": 22.273736
    },
    {
        "city_name": "汕头市",
        "city_code": "440500",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 116.67775,
        "city_lat": 23.356162
    },
    {
        "city_name": "佛山市",
        "city_code": "440600",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 113.116428,
        "city_lat": 23.024395
    },
    {
        "city_name": "江门市",
        "city_code": "440700",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 113.076222,
        "city_lat": 22.581387
    },
    {
        "city_name": "湛江市",
        "city_code": "440800",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 110.354868,
        "city_lat": 21.27322
    },
    {
        "city_name": "茂名市",
        "city_code": "440900",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 110.920728,
        "city_lat": 21.666067
    },
    {
        "city_name": "肇庆市",
        "city_code": "441200",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 112.46001,
        "city_lat": 23.049509
    },
    {
        "city_name": "惠州市",
        "city_code": "441300",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 114.411771,
        "city_lat": 23.113454
    },
    {
        "city_name": "梅州市",
        "city_code": "441400",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 116.117805,
        "city_lat": 24.291061
    },
    {
        "city_name": "汕尾市",
        "city_code": "441500",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 115.37032,
        "city_lat": 22.788461
    },
    {
        "city_name": "河源市",
        "city_code": "441600",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 114.695956,
        "city_lat": 23.746307
    },
    {
        "city_name": "阳江市",
        "city_code": "441700",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 111.977493,
        "city_lat": 21.861032
    },
    {
        "city_name": "清远市",
        "city_code": "441800",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 113.050683,
        "city_lat": 23.684481
    },
    {
        "city_name": "东莞市",
        "city_code": "441900",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 113.746411,
        "city_lat": 23.022718
    },
    {
        "city_name": "中山市",
        "city_code": "442000",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 113.387122,
        "city_lat": 22.518642
    },
    {
        "city_name": "潮州市",
        "city_code": "445100",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 116.618603,
        "city_lat": 23.65945
    },
    {
        "city_name": "揭阳市",
        "city_code": "445200",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 116.368004,
        "city_lat": 23.552119
    },
    {
        "city_name": "云浮市",
        "city_code": "445300",
        "province_name": "广东省",
        "province_code": "440000",
        "city_lng": 112.039345,
        "city_lat": 22.917638
    },
    {
        "city_name": "南宁市",
        "city_code": "450100",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 108.362571,
        "city_lat": 22.819087
    },
    {
        "city_name": "柳州市",
        "city_code": "450200",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 109.410903,
        "city_lat": 24.328116
    },
    {
        "city_name": "桂林市",
        "city_code": "450300",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 110.285434,
        "city_lat": 25.276446
    },
    {
        "city_name": "梧州市",
        "city_code": "450400",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 111.274029,
        "city_lat": 23.479624
    },
    {
        "city_name": "北海市",
        "city_code": "450500",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 109.115786,
        "city_lat": 21.483501
    },
    {
        "city_name": "防城港市",
        "city_code": "450600",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 108.35003,
        "city_lat": 21.689613
    },
    {
        "city_name": "钦州市",
        "city_code": "450700",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 108.650417,
        "city_lat": 21.983765
    },
    {
        "city_name": "贵港市",
        "city_code": "450800",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 109.594884,
        "city_lat": 23.114499
    },
    {
        "city_name": "玉林市",
        "city_code": "450900",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 110.1516763,
        "city_lat": 22.64397361
    },
    {
        "city_name": "百色市",
        "city_code": "451000",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 106.614424,
        "city_lat": 23.906265
    },
    {
        "city_name": "贺州市",
        "city_code": "451100",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 111.561423,
        "city_lat": 24.406488
    },
    {
        "city_name": "河池市",
        "city_code": "451200",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 108.081146,
        "city_lat": 24.695665
    },
    {
        "city_name": "来宾市",
        "city_code": "451300",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 109.216988,
        "city_lat": 23.752993
    },
    {
        "city_name": "崇左市",
        "city_code": "451400",
        "province_name": "广西壮族自治区",
        "province_code": "450000",
        "city_lng": 107.360852,
        "city_lat": 22.379312
    },
    {
        "city_name": "海口市",
        "city_code": "460100",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 110.323956,
        "city_lat": 20.033443
    },
    {
        "city_name": "三亚市",
        "city_code": "460200",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.51326,
        "city_lat": 18.237919
    },
    {
        "city_name": "三沙市",
        "city_code": "460300",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 112.337417,
        "city_lat": 16.837423
    },
    {
        "city_name": "儋州市",
        "city_code": "460400",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.576613,
        "city_lat": 19.522896
    },
    {
        "city_name": "五指山市",
        "city_code": "469001",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.516662,
        "city_lat": 18.776921
    },
    {
        "city_name": "琼海市",
        "city_code": "469002",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 110.466785,
        "city_lat": 19.246011
    },
    {
        "city_name": "文昌市",
        "city_code": "469005",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 110.753975,
        "city_lat": 19.612986
    },
    {
        "city_name": "万宁市",
        "city_code": "469006",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 110.388793,
        "city_lat": 18.796216
    },
    {
        "city_name": "东方市",
        "city_code": "469007",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 108.653789,
        "city_lat": 19.10198
    },
    {
        "city_name": "定安县",
        "city_code": "469021",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 110.323959,
        "city_lat": 19.699211
    },
    {
        "city_name": "屯昌县",
        "city_code": "469022",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 110.102773,
        "city_lat": 19.362916
    },
    {
        "city_name": "澄迈县",
        "city_code": "469023",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 110.007147,
        "city_lat": 19.737095
    },
    {
        "city_name": "临高县",
        "city_code": "469024",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.687697,
        "city_lat": 19.908293
    },
    {
        "city_name": "白沙黎族自治县",
        "city_code": "469025",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.452606,
        "city_lat": 19.224584
    },
    {
        "city_name": "昌江黎族自治县",
        "city_code": "469026",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.053351,
        "city_lat": 19.260968
    },
    {
        "city_name": "乐东黎族自治县",
        "city_code": "469027",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.175444,
        "city_lat": 18.74758
    },
    {
        "city_name": "陵水黎族自治县",
        "city_code": "469028",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 110.037218,
        "city_lat": 18.505006
    },
    {
        "city_name": "保亭黎族苗族自治县",
        "city_code": "469029",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.70245,
        "city_lat": 18.636371
    },
    {
        "city_name": "琼中黎族苗族自治县",
        "city_code": "469030",
        "province_name": "海南省",
        "province_code": "460000",
        "city_lng": 109.839996,
        "city_lat": 19.03557
    },
    {
        "city_name": "重庆市",
        "city_code": "500100",
        "province_name": "重庆市",
        "province_code": "500000",
        "city_lng": 106.530635,
        "city_lat": 29.54460611
    },
    {
        "city_name": "成都市",
        "city_code": "510100",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 104.062269,
        "city_lat": 30.661123
    },
    {
        "city_name": "自贡市",
        "city_code": "510300",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 104.775735,
        "city_lat": 29.342052
    },
    {
        "city_name": "攀枝花市",
        "city_code": "510400",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 101.71713,
        "city_lat": 26.585834
    },
    {
        "city_name": "泸州市",
        "city_code": "510500",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 105.438973,
        "city_lat": 28.874729
    },
    {
        "city_name": "德阳市",
        "city_code": "510600",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 104.395213,
        "city_lat": 31.128928
    },
    {
        "city_name": "绵阳市",
        "city_code": "510700",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 104.676409,
        "city_lat": 31.469721
    },
    {
        "city_name": "广元市",
        "city_code": "510800",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 105.84462,
        "city_lat": 32.436291
    },
    {
        "city_name": "遂宁市",
        "city_code": "510900",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 105.589321,
        "city_lat": 30.535382
    },
    {
        "city_name": "内江市",
        "city_code": "511000",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 105.055217,
        "city_lat": 29.582726
    },
    {
        "city_name": "乐山市",
        "city_code": "511100",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 103.76317,
        "city_lat": 29.55496
    },
    {
        "city_name": "南充市",
        "city_code": "511300",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 106.106706,
        "city_lat": 30.839582
    },
    {
        "city_name": "眉山市",
        "city_code": "511400",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 103.846438,
        "city_lat": 30.078333
    },
    {
        "city_name": "宜宾市",
        "city_code": "511500",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 104.640772,
        "city_lat": 28.75516
    },
    {
        "city_name": "广安市",
        "city_code": "511600",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 106.629435,
        "city_lat": 30.458738
    },
    {
        "city_name": "达州市",
        "city_code": "511700",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 107.463239,
        "city_lat": 31.210769
    },
    {
        "city_name": "雅安市",
        "city_code": "511800",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 103.011416,
        "city_lat": 29.983182
    },
    {
        "city_name": "巴中市",
        "city_code": "511900",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 106.740703,
        "city_lat": 31.867347
    },
    {
        "city_name": "资阳市",
        "city_code": "512000",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 104.625458,
        "city_lat": 30.131377
    },
    {
        "city_name": "阿坝藏族羌族自治州",
        "city_code": "513200",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 102.2285647,
        "city_lat": 31.90576286
    },
    {
        "city_name": "甘孜藏族自治州",
        "city_code": "513300",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 101.9692321,
        "city_lat": 30.05514411
    },
    {
        "city_name": "凉山彝族自治州",
        "city_code": "513400",
        "province_name": "四川省",
        "province_code": "510000",
        "city_lng": 102.265963,
        "city_lat": 27.885029
    },
    {
        "city_name": "贵阳市",
        "city_code": "520100",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 106.626641,
        "city_lat": 26.65096
    },
    {
        "city_name": "六盘水市",
        "city_code": "520200",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 104.82845,
        "city_lat": 26.596285
    },
    {
        "city_name": "遵义市",
        "city_code": "520300",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 106.923402,
        "city_lat": 27.728975
    },
    {
        "city_name": "安顺市",
        "city_code": "520400",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 105.944249,
        "city_lat": 26.256607
    },
    {
        "city_name": "毕节市",
        "city_code": "520500",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 105.280911,
        "city_lat": 27.306043
    },
    {
        "city_name": "铜仁市",
        "city_code": "520600",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 109.185024,
        "city_lat": 27.734818
    },
    {
        "city_name": "黔西南布依族苗族自治州",
        "city_code": "522300",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 104.9005578,
        "city_lat": 25.09514806
    },
    {
        "city_name": "黔东南苗族侗族自治州",
        "city_code": "522600",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 107.9853526,
        "city_lat": 26.58399177
    },
    {
        "city_name": "黔南布依族苗族自治州",
        "city_code": "522700",
        "province_name": "贵州省",
        "province_code": "520000",
        "city_lng": 107.129779,
        "city_lat": 26.043429
    },
    {
        "city_name": "昆明市",
        "city_code": "530100",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 102.720721,
        "city_lat": 25.041309
    },
    {
        "city_name": "曲靖市",
        "city_code": "530300",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 103.794201,
        "city_lat": 25.493003
    },
    {
        "city_name": "玉溪市",
        "city_code": "530400",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 102.545331,
        "city_lat": 24.354977
    },
    {
        "city_name": "保山市",
        "city_code": "530500",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 99.160878,
        "city_lat": 25.114891
    },
    {
        "city_name": "昭通市",
        "city_code": "530600",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 103.714685,
        "city_lat": 27.341577
    },
    {
        "city_name": "丽江市",
        "city_code": "530700",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 100.225258,
        "city_lat": 26.8583
    },
    {
        "city_name": "普洱市",
        "city_code": "530800",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 100.969117,
        "city_lat": 22.78064
    },
    {
        "city_name": "临沧市",
        "city_code": "530900",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 100.078252,
        "city_lat": 23.880224
    },
    {
        "city_name": "楚雄彝族自治州",
        "city_code": "532300",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 101.5293822,
        "city_lat": 25.06635567
    },
    {
        "city_name": "红河哈尼族彝族自治州",
        "city_code": "532500",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 103.3840648,
        "city_lat": 23.36771752
    },
    {
        "city_name": "文山壮族苗族自治州",
        "city_code": "532600",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 104.2462943,
        "city_lat": 23.37408685
    },
    {
        "city_name": "西双版纳傣族自治州",
        "city_code": "532800",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 100.795887,
        "city_lat": 22.012061
    },
    {
        "city_name": "大理白族自治州",
        "city_code": "532900",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 100.2236748,
        "city_lat": 25.59689964
    },
    {
        "city_name": "德宏傣族景颇族自治州",
        "city_code": "533100",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 98.051183,
        "city_lat": 24.623306
    },
    {
        "city_name": "怒江傈僳族自治州",
        "city_code": "533300",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 98.85993204,
        "city_lat": 25.86067698
    },
    {
        "city_name": "迪庆藏族自治州",
        "city_code": "533400",
        "province_name": "云南省",
        "province_code": "530000",
        "city_lng": 99.425771,
        "city_lat": 27.876819
    },
    {
        "city_name": "拉萨市",
        "city_code": "540100",
        "province_name": "西藏自治区",
        "province_code": "540000",
        "city_lng": 91.11292,
        "city_lat": 29.646799
    },
    {
        "city_name": "日喀则市",
        "city_code": "540200",
        "province_name": "西藏自治区",
        "province_code": "540000",
        "city_lng": 88.88521,
        "city_lat": 29.272953
    },
    {
        "city_name": "昌都市",
        "city_code": "540300",
        "province_name": "西藏自治区",
        "province_code": "540000",
        "city_lng": 97.171663,
        "city_lat": 31.143006
    },
    {
        "city_name": "林芝市",
        "city_code": "540400",
        "province_name": "西藏自治区",
        "province_code": "540000",
        "city_lng": 94.48391,
        "city_lat": 29.57562
    },
    {
        "city_name": "山南市",
        "city_code": "540500",
        "province_name": "西藏自治区",
        "province_code": "540000",
        "city_lng": 91.771867,
        "city_lat": 29.240094
    },
    {
        "city_name": "那曲市",
        "city_code": "540600",
        "province_name": "西藏自治区",
        "province_code": "540000",
        "city_lng": 92.060214,
        "city_lat": 31.476004
    },
    {
        "city_name": "阿里地区",
        "city_code": "542500",
        "province_name": "西藏自治区",
        "province_code": "540000",
        "city_lng": 82.112505,
        "city_lat": 33.229404
    },
    {
        "city_name": "西安市",
        "city_code": "610100",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 108.93949,
        "city_lat": 34.266345
    },
    {
        "city_name": "铜川市",
        "city_code": "610200",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 108.940437,
        "city_lat": 34.897815
    },
    {
        "city_name": "宝鸡市",
        "city_code": "610300",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 107.23261,
        "city_lat": 34.363346
    },
    {
        "city_name": "咸阳市",
        "city_code": "610400",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 108.704595,
        "city_lat": 34.331388
    },
    {
        "city_name": "渭南市",
        "city_code": "610500",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 109.50498,
        "city_lat": 34.501276
    },
    {
        "city_name": "延安市",
        "city_code": "610600",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 109.484341,
        "city_lat": 36.58517
    },
    {
        "city_name": "汉中市",
        "city_code": "610700",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 107.018931,
        "city_lat": 33.069458
    },
    {
        "city_name": "榆林市",
        "city_code": "610800",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 109.728989,
        "city_lat": 38.284679
    },
    {
        "city_name": "安康市",
        "city_code": "610900",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 109.024456,
        "city_lat": 32.686932
    },
    {
        "city_name": "商洛市",
        "city_code": "611000",
        "province_name": "陕西省",
        "province_code": "610000",
        "city_lng": 109.935418,
        "city_lat": 33.872035
    },
    {
        "city_name": "兰州市",
        "city_code": "620100",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 103.831741,
        "city_lat": 36.061685
    },
    {
        "city_name": "嘉峪关市",
        "city_code": "620200",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 98.28908,
        "city_lat": 39.771081
    },
    {
        "city_name": "金昌市",
        "city_code": "620300",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 102.186125,
        "city_lat": 38.51971
    },
    {
        "city_name": "白银市",
        "city_code": "620400",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 104.134886,
        "city_lat": 36.54459
    },
    {
        "city_name": "天水市",
        "city_code": "620500",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 105.720915,
        "city_lat": 34.582157
    },
    {
        "city_name": "武威市",
        "city_code": "620600",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 102.636228,
        "city_lat": 37.92789
    },
    {
        "city_name": "张掖市",
        "city_code": "620700",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 100.448075,
        "city_lat": 38.92526
    },
    {
        "city_name": "平凉市",
        "city_code": "620800",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 106.661075,
        "city_lat": 35.543492
    },
    {
        "city_name": "酒泉市",
        "city_code": "620900",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 98.493282,
        "city_lat": 39.731704
    },
    {
        "city_name": "庆阳市",
        "city_code": "621000",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 107.627715,
        "city_lat": 35.739234
    },
    {
        "city_name": "定西市",
        "city_code": "621100",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 104.623368,
        "city_lat": 35.581142
    },
    {
        "city_name": "陇南市",
        "city_code": "621200",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 104.919019,
        "city_lat": 33.402421
    },
    {
        "city_name": "临夏回族自治州",
        "city_code": "622900",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 103.2152492,
        "city_lat": 35.59851435
    },
    {
        "city_name": "甘南藏族自治州",
        "city_code": "623000",
        "province_name": "甘肃省",
        "province_code": "620000",
        "city_lng": 102.9174425,
        "city_lat": 34.99221118
    },
    {
        "city_name": "西宁市",
        "city_code": "630100",
        "province_name": "青海省",
        "province_code": "630000",
        "city_lng": 101.775854,
        "city_lat": 36.617341
    },
    {
        "city_name": "海东市",
        "city_code": "630200",
        "province_name": "青海省",
        "province_code": "630000",
        "city_lng": 102.371351,
        "city_lat": 36.393734
    },
    {
        "city_name": "海北藏族自治州",
        "city_code": "632200",
        "province_name": "青海省",
        "province_code": "630000",
        "city_lng": 100.8798022,
        "city_lat": 36.9606541
    },
    {
        "city_name": "黄南藏族自治州",
        "city_code": "632300",
        "province_name": "青海省",
        "province_code": "630000",
        "city_lng": 102.0076003,
        "city_lat": 35.52285155
    },
    {
        "city_name": "海南藏族自治州",
        "city_code": "632500",
        "province_name": "青海省",
        "province_code": "630000",
        "city_lng": 100.6240661,
        "city_lat": 36.2843638
    },
    {
        "city_name": "果洛藏族自治州",
        "city_code": "632600",
        "province_name": "青海省",
        "province_code": "630000",
        "city_lng": 100.2237228,
        "city_lat": 34.48048458
    },
    {
        "city_name": "玉树藏族自治州",
        "city_code": "632700",
        "province_name": "青海省",
        "province_code": "630000",
        "city_lng": 97.01331614,
        "city_lat": 33.00623991
    },
    {
        "city_name": "海西蒙古族藏族自治州",
        "city_code": "632800",
        "province_name": "青海省",
        "province_code": "630000",
        "city_lng": 94.734952,
        "city_lat": 37.099912
    },
    {
        "city_name": "银川市",
        "city_code": "640100",
        "province_name": "宁夏回族自治区",
        "province_code": "640000",
        "city_lng": 106.228061,
        "city_lat": 38.485961
    },
    {
        "city_name": "石嘴山市",
        "city_code": "640200",
        "province_name": "宁夏回族自治区",
        "province_code": "640000",
        "city_lng": 106.37946,
        "city_lat": 38.983251
    },
    {
        "city_name": "吴忠市",
        "city_code": "640300",
        "province_name": "宁夏回族自治区",
        "province_code": "640000",
        "city_lng": 106.194369,
        "city_lat": 37.99698
    },
    {
        "city_name": "固原市",
        "city_code": "640400",
        "province_name": "宁夏回族自治区",
        "province_code": "640000",
        "city_lng": 106.238377,
        "city_lat": 36.015962
    },
    {
        "city_name": "中卫市",
        "city_code": "640500",
        "province_name": "宁夏回族自治区",
        "province_code": "640000",
        "city_lng": 105.192969,
        "city_lat": 37.499687
    },
    {
        "city_name": "乌鲁木齐市",
        "city_code": "650100",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 87.613831,
        "city_lat": 43.825135
    },
    {
        "city_name": "克拉玛依市",
        "city_code": "650200",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 84.886763,
        "city_lat": 45.578614
    },
    {
        "city_name": "吐鲁番市",
        "city_code": "650400",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 89.193275,
        "city_lat": 42.95218
    },
    {
        "city_name": "哈密市",
        "city_code": "650500",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 93.513767,
        "city_lat": 42.817016
    },
    {
        "city_name": "昌吉回族自治州",
        "city_code": "652300",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 87.29603813,
        "city_lat": 44.0070579
    },
    {
        "city_name": "博尔塔拉蒙古自治州",
        "city_code": "652700",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 82.05243627,
        "city_lat": 44.91365137
    },
    {
        "city_name": "巴音郭楞蒙古自治州",
        "city_code": "652800",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 87.08858,
        "city_lat": 39.880987
    },
    {
        "city_name": "阿克苏地区",
        "city_code": "652900",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 80.26984618,
        "city_lat": 41.1717309
    },
    {
        "city_name": "克孜勒苏柯尔克孜自治州",
        "city_code": "653000",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 76.13756448,
        "city_lat": 39.75034558
    },
    {
        "city_name": "喀什地区",
        "city_code": "653100",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 75.99297327,
        "city_lat": 39.47062719
    },
    {
        "city_name": "和田地区",
        "city_code": "653200",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 79.93023864,
        "city_lat": 37.11677449
    },
    {
        "city_name": "伊犁哈萨克自治州",
        "city_code": "654000",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 81.29785353,
        "city_lat": 43.9222481
    },
    {
        "city_name": "塔城地区",
        "city_code": "654200",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 82.97488058,
        "city_lat": 46.75868363
    },
    {
        "city_name": "阿勒泰地区",
        "city_code": "654300",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 88.832863,
        "city_lat": 46.879531
    },
    {
        "city_name": "胡杨河市",
        "city_code": "659000",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 84.827592,
        "city_lat": 44.692894
    },
    {
        "city_name": "石河子市",
        "city_code": "659001",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 86.041075,
        "city_lat": 44.305886
    },
    {
        "city_name": "阿拉尔市",
        "city_code": "659002",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 81.285884,
        "city_lat": 40.541914
    },
    {
        "city_name": "图木舒克市",
        "city_code": "659003",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 79.077978,
        "city_lat": 39.867316
    },
    {
        "city_name": "五家渠市",
        "city_code": "659004",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 87.526884,
        "city_lat": 44.167401
    },
    {
        "city_name": "北屯市",
        "city_code": "659005",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 87.82151,
        "city_lat": 47.351
    },
    {
        "city_name": "铁门关市",
        "city_code": "659006",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 85.501221,
        "city_lat": 41.827251
    },
    {
        "city_name": "双河市",
        "city_code": "659007",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 91.132212,
        "city_lat": 29.660361
    },
    {
        "city_name": "可克达拉市",
        "city_code": "659008",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 81.04436,
        "city_lat": 43.94573
    },
    {
        "city_name": "昆玉市",
        "city_code": "659009",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 79.291083,
        "city_lat": 37.209642
    },
    {
        "city_name": "新星市",
        "city_code": "659100",
        "province_name": "新疆维吾尔自治区",
        "province_code": "650000",
        "city_lng": 93.73782,
        "city_lat": 42.79888
    },
    {
        "city_name": "台北市",
        "city_code": "710100",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 121.47,
        "city_lat": 25.02
    },
    {
        "city_name": "高雄市",
        "city_code": "710200",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.28,
        "city_lat": 22.62
    },
    {
        "city_name": "新北市",
        "city_code": "710300",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 121.663675,
        "city_lat": 25.1853
    },
    {
        "city_name": "台中市",
        "city_code": "710400",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.72,
        "city_lat": 24.25
    },
    {
        "city_name": "台南市",
        "city_code": "710500",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.185,
        "city_lat": 23.0472
    },
    {
        "city_name": "桃园市",
        "city_code": "710600",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 121.3,
        "city_lat": 24.97
    },
    {
        "city_name": "基隆市",
        "city_code": "719001",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 121.746248,
        "city_lat": 25.130741
    },
    {
        "city_name": "新竹市",
        "city_code": "719002",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.95,
        "city_lat": 24.82
    },
    {
        "city_name": "嘉义市",
        "city_code": "719003",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.43,
        "city_lat": 23.48
    },
    {
        "city_name": "新竹县",
        "city_code": "719004",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 121.02332,
        "city_lat": 24.82958
    },
    {
        "city_name": "宜兰县",
        "city_code": "719005",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 121.75,
        "city_lat": 24.77
    },
    {
        "city_name": "苗栗县",
        "city_code": "719006",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.8,
        "city_lat": 24.53
    },
    {
        "city_name": "彰化县",
        "city_code": "719007",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.416,
        "city_lat": 24
    },
    {
        "city_name": "云林县",
        "city_code": "719008",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.53,
        "city_lat": 23.72
    },
    {
        "city_name": "南投县",
        "city_code": "719009",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.67,
        "city_lat": 23.92
    },
    {
        "city_name": "嘉义县",
        "city_code": "719010",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.3,
        "city_lat": 23.5
    },
    {
        "city_name": "屏东县",
        "city_code": "719011",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 120.48,
        "city_lat": 22.67
    },
    {
        "city_name": "台东县",
        "city_code": "719012",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 121.15,
        "city_lat": 22.75
    },
    {
        "city_name": "花莲县",
        "city_code": "719013",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 121.6,
        "city_lat": 23.98
    },
    {
        "city_name": "澎湖县",
        "city_code": "719014",
        "province_name": "台湾省",
        "province_code": "710000",
        "city_lng": 119.566417,
        "city_lat": 23.569733
    },
    {
        "city_name": "香港",
        "city_code": "810000",
        "province_name": "香港",
        "province_code": "810000",
        "city_lng": 114.1,
        "city_lat": 22.2
    },
    {
        "city_name": "澳门",
        "city_code": "820000",
        "province_name": "澳门",
        "province_code": "820000",
        "city_lng": 113.5,
        "city_lat": 22.2
    },
    {
        "city_name": "海域",
        "city_code": "999900",
        "province_name": "苏鲁交界",
        "province_code": "990000",
        "city_lng": 119.90205222822,
        "city_lat": 35.0141770078087
    }
]

export let cityListOne = [
    {
        "city_name": "北京",
        "city_lng": 116.395645,
        "city_lat": 39.929986,
        "city_g": "116.395645,39.929986|12",
        "province_name": "北京",
        "province_lng": 116.395645,
        "province_lat": 39.929986,
        "province_g": "116.395645,39.929986|12"
    },
    {
        "city_name": "上海",
        "city_lng": 121.487899,
        "city_lat": 31.249162,
        "city_g": "121.487899,31.249162|12",
        "province_name": "上海",
        "province_lng": 121.487899,
        "province_lat": 31.249162,
        "province_g": "121.487899,31.249162|12"
    },
    {
        "city_name": "天津",
        "city_lng": 117.210813,
        "city_lat": 39.14393,
        "city_g": "117.210813,39.14393|12",
        "province_name": "天津",
        "province_lng": 117.210813,
        "province_lat": 39.14393,
        "province_g": "117.210813,39.14393|12"
    },
    {
        "city_name": "重庆",
        "city_lng": 106.530635,
        "city_lat": 29.544606,
        "city_g": "106.530635,29.544606|12",
        "province_name": "重庆",
        "province_lng": 106.530635,
        "province_lat": 29.544606,
        "province_g": "106.530635,29.544606|12"
    },
    {
        "city_name": "香港",
        "city_lng": 114.186124,
        "city_lat": 22.293586,
        "city_g": "114.186124,22.293586|11",
        "province_name": "香港",
        "province_lng": 114.186124,
        "province_lat": 22.293586,
        "province_g": "114.186124,22.293586|11"
    },
    {
        "city_name": "澳门",
        "city_lng": 113.557519,
        "city_lat": 22.204118,
        "city_g": "113.557519,22.204118|13",
        "province_name": "澳门",
        "province_lng": 113.557519,
        "province_lat": 22.204118,
        "province_g": "113.557519,22.204118|13"
    },
    {
        "city_name": "台湾",
        "city_lng": 120.961454,
        "city_lat": 23.80406,
        "city_g": "120.961454,23.80406|8",
        "province_name": "台湾",
        "province_lng": 120.961454,
        "province_lat": 23.80406,
        "province_g": "120.961454,23.80406|8"
    },
    {
        "city_name": "合肥",
        "city_lng": 117.282699,
        "city_lat": 31.866942,
        "city_g": "117.282699,31.866942|12",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "安庆",
        "city_lng": 117.058739,
        "city_lat": 30.537898,
        "city_g": "117.058739,30.537898|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "蚌埠",
        "city_lng": 117.35708,
        "city_lat": 32.929499,
        "city_g": "117.35708,32.929499|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "亳州",
        "city_lng": 115.787928,
        "city_lat": 33.871211,
        "city_g": "115.787928,33.871211|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "巢湖",
        "city_lng": 117.88049,
        "city_lat": 31.608733,
        "city_g": "117.88049,31.608733|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "池州",
        "city_lng": 117.494477,
        "city_lat": 30.660019,
        "city_g": "117.494477,30.660019|14",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "滁州",
        "city_lng": 118.32457,
        "city_lat": 32.317351,
        "city_g": "118.32457,32.317351|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "阜阳",
        "city_lng": 115.820932,
        "city_lat": 32.901211,
        "city_g": "115.820932,32.901211|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "淮北",
        "city_lng": 116.791447,
        "city_lat": 33.960023,
        "city_g": "116.791447,33.960023|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "淮南",
        "city_lng": 117.018639,
        "city_lat": 32.642812,
        "city_g": "117.018639,32.642812|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "黄山",
        "city_lng": 118.29357,
        "city_lat": 29.734435,
        "city_g": "118.29357,29.734435|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "六安",
        "city_lng": 116.505253,
        "city_lat": 31.755558,
        "city_g": "116.505253,31.755558|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "马鞍山",
        "city_lng": 118.515882,
        "city_lat": 31.688528,
        "city_g": "118.515882,31.688528|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "宿州",
        "city_lng": 116.988692,
        "city_lat": 33.636772,
        "city_g": "116.988692,33.636772|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "铜陵",
        "city_lng": 117.819429,
        "city_lat": 30.94093,
        "city_g": "117.819429,30.94093|14",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "芜湖",
        "city_lng": 118.384108,
        "city_lat": 31.36602,
        "city_g": "118.384108,31.36602|12",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "宣城",
        "city_lng": 118.752096,
        "city_lat": 30.951642,
        "city_g": "118.752096,30.951642|13",
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "city_name": "福州",
        "city_lng": 119.330221,
        "city_lat": 26.047125,
        "city_g": "119.330221,26.047125|12",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "龙岩",
        "city_lng": 117.017997,
        "city_lat": 25.078685,
        "city_g": "117.017997,25.078685|13",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "南平",
        "city_lng": 118.181883,
        "city_lat": 26.643626,
        "city_g": "118.181883,26.643626|13",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "宁德",
        "city_lng": 119.542082,
        "city_lat": 26.656527,
        "city_g": "119.542082,26.656527|14",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "莆田",
        "city_lng": 119.077731,
        "city_lat": 25.44845,
        "city_g": "119.077731,25.44845|13",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "泉州",
        "city_lng": 118.600362,
        "city_lat": 24.901652,
        "city_g": "118.600362,24.901652|12",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "三明",
        "city_lng": 117.642194,
        "city_lat": 26.270835,
        "city_g": "117.642194,26.270835|14",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "厦门",
        "city_lng": 118.103886,
        "city_lat": 24.489231,
        "city_g": "118.103886,24.489231|12",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "漳州",
        "city_lng": 117.676205,
        "city_lat": 24.517065,
        "city_g": "117.676205,24.517065|12",
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "city_name": "兰州",
        "city_lng": 103.823305,
        "city_lat": 36.064226,
        "city_g": "103.823305,36.064226|12",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "白银",
        "city_lng": 104.171241,
        "city_lat": 36.546682,
        "city_g": "104.171241,36.546682|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "定西",
        "city_lng": 104.626638,
        "city_lat": 35.586056,
        "city_g": "104.626638,35.586056|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "甘南州",
        "city_lng": 102.917442,
        "city_lat": 34.992211,
        "city_g": "102.917442,34.992211|14",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "嘉峪关",
        "city_lng": 98.281635,
        "city_lat": 39.802397,
        "city_g": "98.281635,39.802397|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "金昌",
        "city_lng": 102.208126,
        "city_lat": 38.516072,
        "city_g": "102.208126,38.516072|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "酒泉",
        "city_lng": 98.508415,
        "city_lat": 39.741474,
        "city_g": "98.508415,39.741474|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "临夏州",
        "city_lng": 103.215249,
        "city_lat": 35.598514,
        "city_g": "103.215249,35.598514|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "陇南",
        "city_lng": 104.934573,
        "city_lat": 33.39448,
        "city_g": "104.934573,33.39448|14",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "平凉",
        "city_lng": 106.688911,
        "city_lat": 35.55011,
        "city_g": "106.688911,35.55011|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "庆阳",
        "city_lng": 107.644227,
        "city_lat": 35.726801,
        "city_g": "107.644227,35.726801|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "天水",
        "city_lng": 105.736932,
        "city_lat": 34.584319,
        "city_g": "105.736932,34.584319|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "武威",
        "city_lng": 102.640147,
        "city_lat": 37.933172,
        "city_g": "102.640147,37.933172|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "张掖",
        "city_lng": 100.459892,
        "city_lat": 38.93932,
        "city_g": "100.459892,38.93932|13",
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "city_name": "广州",
        "city_lng": 113.30765,
        "city_lat": 23.120049,
        "city_g": "113.30765,23.120049|12",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "潮州",
        "city_lng": 116.630076,
        "city_lat": 23.661812,
        "city_g": "116.630076,23.661812|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "东莞",
        "city_lng": 113.763434,
        "city_lat": 23.043024,
        "city_g": "113.763434,23.043024|12",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "佛山",
        "city_lng": 113.134026,
        "city_lat": 23.035095,
        "city_g": "113.134026,23.035095|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "河源",
        "city_lng": 114.713721,
        "city_lat": 23.757251,
        "city_g": "114.713721,23.757251|12",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "惠州",
        "city_lng": 114.410658,
        "city_lat": 23.11354,
        "city_g": "114.410658,23.11354|12",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "江门",
        "city_lng": 113.078125,
        "city_lat": 22.575117,
        "city_g": "113.078125,22.575117|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "揭阳",
        "city_lng": 116.379501,
        "city_lat": 23.547999,
        "city_g": "116.379501,23.547999|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "茂名",
        "city_lng": 110.931245,
        "city_lat": 21.668226,
        "city_g": "110.931245,21.668226|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "梅州",
        "city_lng": 116.126403,
        "city_lat": 24.304571,
        "city_g": "116.126403,24.304571|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "清远",
        "city_lng": 113.040773,
        "city_lat": 23.698469,
        "city_g": "113.040773,23.698469|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "汕头",
        "city_lng": 116.72865,
        "city_lat": 23.383908,
        "city_g": "116.72865,23.383908|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "汕尾",
        "city_lng": 115.372924,
        "city_lat": 22.778731,
        "city_g": "115.372924,22.778731|14",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "韶关",
        "city_lng": 113.594461,
        "city_lat": 24.80296,
        "city_g": "113.594461,24.80296|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "深圳",
        "city_lng": 114.025974,
        "city_lat": 22.546054,
        "city_g": "114.025974,22.546054|12",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "阳江",
        "city_lng": 111.97701,
        "city_lat": 21.871517,
        "city_g": "111.97701,21.871517|14",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "云浮",
        "city_lng": 112.050946,
        "city_lat": 22.937976,
        "city_g": "112.050946,22.937976|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "湛江",
        "city_lng": 110.365067,
        "city_lat": 21.257463,
        "city_g": "110.365067,21.257463|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "肇庆",
        "city_lng": 112.479653,
        "city_lat": 23.078663,
        "city_g": "112.479653,23.078663|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "中山",
        "city_lng": 113.42206,
        "city_lat": 22.545178,
        "city_g": "113.42206,22.545178|12",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "珠海",
        "city_lng": 113.562447,
        "city_lat": 22.256915,
        "city_g": "113.562447,22.256915|13",
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "city_name": "南宁",
        "city_lng": 108.297234,
        "city_lat": 22.806493,
        "city_g": "108.297234,22.806493|12",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "百色",
        "city_lng": 106.631821,
        "city_lat": 23.901512,
        "city_g": "106.631821,23.901512|13",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "北海",
        "city_lng": 109.122628,
        "city_lat": 21.472718,
        "city_g": "109.122628,21.472718|13",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "崇左",
        "city_lng": 107.357322,
        "city_lat": 22.415455,
        "city_g": "107.357322,22.415455|14",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "防城港",
        "city_lng": 108.351791,
        "city_lat": 21.617398,
        "city_g": "108.351791,21.617398|15",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "桂林",
        "city_lng": 110.26092,
        "city_lat": 25.262901,
        "city_g": "110.26092,25.262901|12",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "贵港",
        "city_lng": 109.613708,
        "city_lat": 23.103373,
        "city_g": "109.613708,23.103373|13",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "河池",
        "city_lng": 108.069948,
        "city_lat": 24.699521,
        "city_g": "108.069948,24.699521|14",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "贺州",
        "city_lng": 111.552594,
        "city_lat": 24.411054,
        "city_g": "111.552594,24.411054|14",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "来宾",
        "city_lng": 109.231817,
        "city_lat": 23.741166,
        "city_g": "109.231817,23.741166|14",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "柳州",
        "city_lng": 109.422402,
        "city_lat": 24.329053,
        "city_g": "109.422402,24.329053|12",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "钦州",
        "city_lng": 108.638798,
        "city_lat": 21.97335,
        "city_g": "108.638798,21.97335|13",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "梧州",
        "city_lng": 111.305472,
        "city_lat": 23.485395,
        "city_g": "111.305472,23.485395|13",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "玉林",
        "city_lng": 110.151676,
        "city_lat": 22.643974,
        "city_g": "110.151676,22.643974|14",
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "city_name": "贵阳",
        "city_lng": 106.709177,
        "city_lat": 26.629907,
        "city_g": "106.709177,26.629907|12",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "安顺",
        "city_lng": 105.92827,
        "city_lat": 26.228595,
        "city_g": "105.92827,26.228595|13",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "毕节地区",
        "city_lng": 105.300492,
        "city_lat": 27.302612,
        "city_g": "105.300492,27.302612|14",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "六盘水",
        "city_lng": 104.852087,
        "city_lat": 26.591866,
        "city_g": "104.852087,26.591866|13",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "铜仁地区",
        "city_lng": 109.196161,
        "city_lat": 27.726271,
        "city_g": "109.196161,27.726271|14",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "遵义",
        "city_lng": 106.93126,
        "city_lat": 27.699961,
        "city_g": "106.93126,27.699961|13",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "黔西南州",
        "city_lng": 104.900558,
        "city_lat": 25.095148,
        "city_g": "104.900558,25.095148|11",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "黔东南州",
        "city_lng": 107.985353,
        "city_lat": 26.583992,
        "city_g": "107.985353,26.583992|11",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "黔南州",
        "city_lng": 107.523205,
        "city_lat": 26.264536,
        "city_g": "107.523205,26.264536|11",
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "city_name": "海口",
        "city_lng": 110.330802,
        "city_lat": 20.022071,
        "city_g": "110.330802,20.022071|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "白沙",
        "city_lng": 109.358586,
        "city_lat": 19.216056,
        "city_g": "109.358586,19.216056|12",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "保亭",
        "city_lng": 109.656113,
        "city_lat": 18.597592,
        "city_g": "109.656113,18.597592|12",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "昌江",
        "city_lng": 109.0113,
        "city_lat": 19.222483,
        "city_g": "109.0113,19.222483|12",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "儋州",
        "city_lng": 109.413973,
        "city_lat": 19.571153,
        "city_g": "109.413973,19.571153|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "澄迈",
        "city_lng": 109.996736,
        "city_lat": 19.693135,
        "city_g": "109.996736,19.693135|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "东方",
        "city_lng": 108.85101,
        "city_lat": 18.998161,
        "city_g": "108.85101,18.998161|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "定安",
        "city_lng": 110.32009,
        "city_lat": 19.490991,
        "city_g": "110.32009,19.490991|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "琼海",
        "city_lng": 110.414359,
        "city_lat": 19.21483,
        "city_g": "110.414359,19.21483|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "琼中",
        "city_lng": 109.861849,
        "city_lat": 19.039771,
        "city_g": "109.861849,19.039771|12",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "乐东",
        "city_lng": 109.062698,
        "city_lat": 18.658614,
        "city_g": "109.062698,18.658614|12",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "临高",
        "city_lng": 109.724101,
        "city_lat": 19.805922,
        "city_g": "109.724101,19.805922|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "陵水",
        "city_lng": 109.948661,
        "city_lat": 18.575985,
        "city_g": "109.948661,18.575985|12",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "三亚",
        "city_lng": 109.522771,
        "city_lat": 18.257776,
        "city_g": "109.522771,18.257776|12",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "屯昌",
        "city_lng": 110.063364,
        "city_lat": 19.347749,
        "city_g": "110.063364,19.347749|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "万宁",
        "city_lng": 110.292505,
        "city_lat": 18.839886,
        "city_g": "110.292505,18.839886|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "文昌",
        "city_lng": 110.780909,
        "city_lat": 19.750947,
        "city_g": "110.780909,19.750947|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "五指山",
        "city_lng": 109.51775,
        "city_lat": 18.831306,
        "city_g": "109.51775,18.831306|13",
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "city_name": "石家庄",
        "city_lng": 114.522082,
        "city_lat": 38.048958,
        "city_g": "114.522082,38.048958|12",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "保定",
        "city_lng": 115.49481,
        "city_lat": 38.886565,
        "city_g": "115.49481,38.886565|13",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "沧州",
        "city_lng": 116.863806,
        "city_lat": 38.297615,
        "city_g": "116.863806,38.297615|13",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "承德",
        "city_lng": 117.933822,
        "city_lat": 40.992521,
        "city_g": "117.933822,40.992521|14",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "邯郸",
        "city_lng": 114.482694,
        "city_lat": 36.609308,
        "city_g": "114.482694,36.609308|13",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "衡水",
        "city_lng": 115.686229,
        "city_lat": 37.746929,
        "city_g": "115.686229,37.746929|13",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "廊坊",
        "city_lng": 116.703602,
        "city_lat": 39.518611,
        "city_g": "116.703602,39.518611|13",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "秦皇岛",
        "city_lng": 119.604368,
        "city_lat": 39.945462,
        "city_g": "119.604368,39.945462|12",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "唐山",
        "city_lng": 118.183451,
        "city_lat": 39.650531,
        "city_g": "118.183451,39.650531|13",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "邢台",
        "city_lng": 114.520487,
        "city_lat": 37.069531,
        "city_g": "114.520487,37.069531|13",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "张家口",
        "city_lng": 114.893782,
        "city_lat": 40.811188,
        "city_g": "114.893782,40.811188|13",
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "city_name": "郑州",
        "city_lng": 113.649644,
        "city_lat": 34.75661,
        "city_g": "113.649644,34.75661|12",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "安阳",
        "city_lng": 114.351807,
        "city_lat": 36.110267,
        "city_g": "114.351807,36.110267|12",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "鹤壁",
        "city_lng": 114.29777,
        "city_lat": 35.755426,
        "city_g": "114.29777,35.755426|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "焦作",
        "city_lng": 113.211836,
        "city_lat": 35.234608,
        "city_g": "113.211836,35.234608|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "开封",
        "city_lng": 114.351642,
        "city_lat": 34.801854,
        "city_g": "114.351642,34.801854|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "洛阳",
        "city_lng": 112.447525,
        "city_lat": 34.657368,
        "city_g": "112.447525,34.657368|12",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "漯河",
        "city_lng": 114.046061,
        "city_lat": 33.576279,
        "city_g": "114.046061,33.576279|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "南阳",
        "city_lng": 112.542842,
        "city_lat": 33.01142,
        "city_g": "112.542842,33.01142|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "平顶山",
        "city_lng": 113.300849,
        "city_lat": 33.745301,
        "city_g": "113.300849,33.745301|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "濮阳",
        "city_lng": 115.026627,
        "city_lat": 35.753298,
        "city_g": "115.026627,35.753298|12",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "三门峡",
        "city_lng": 111.181262,
        "city_lat": 34.78332,
        "city_g": "111.181262,34.78332|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "商丘",
        "city_lng": 115.641886,
        "city_lat": 34.438589,
        "city_g": "115.641886,34.438589|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "新乡",
        "city_lng": 113.91269,
        "city_lat": 35.307258,
        "city_g": "113.91269,35.307258|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "信阳",
        "city_lng": 114.085491,
        "city_lat": 32.128582,
        "city_g": "114.085491,32.128582|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "许昌",
        "city_lng": 113.835312,
        "city_lat": 34.02674,
        "city_g": "113.835312,34.02674|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "周口",
        "city_lng": 114.654102,
        "city_lat": 33.623741,
        "city_g": "114.654102,33.623741|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "驻马店",
        "city_lng": 114.049154,
        "city_lat": 32.983158,
        "city_g": "114.049154,32.983158|13",
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "city_name": "哈尔滨",
        "city_lng": 126.657717,
        "city_lat": 45.773225,
        "city_g": "126.657717,45.773225|12",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "大庆",
        "city_lng": 125.02184,
        "city_lat": 46.596709,
        "city_g": "125.02184,46.596709|12",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "大兴安岭地区",
        "city_lng": 124.196104,
        "city_lat": 51.991789,
        "city_g": "124.196104,51.991789|10",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "鹤岗",
        "city_lng": 130.292472,
        "city_lat": 47.338666,
        "city_g": "130.292472,47.338666|13",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "黑河",
        "city_lng": 127.50083,
        "city_lat": 50.25069,
        "city_g": "127.50083,50.25069|14",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "鸡西",
        "city_lng": 130.941767,
        "city_lat": 45.32154,
        "city_g": "130.941767,45.32154|13",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "佳木斯",
        "city_lng": 130.284735,
        "city_lat": 46.81378,
        "city_g": "130.284735,46.81378|12",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "牡丹江",
        "city_lng": 129.608035,
        "city_lat": 44.588521,
        "city_g": "129.608035,44.588521|13",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "七台河",
        "city_lng": 131.019048,
        "city_lat": 45.775005,
        "city_g": "131.019048,45.775005|14",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "齐齐哈尔",
        "city_lng": 123.987289,
        "city_lat": 47.3477,
        "city_g": "123.987289,47.3477|13",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "双鸭山",
        "city_lng": 131.171402,
        "city_lat": 46.655102,
        "city_g": "131.171402,46.655102|13",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "绥化",
        "city_lng": 126.989095,
        "city_lat": 46.646064,
        "city_g": "126.989095,46.646064|13",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "伊春",
        "city_lng": 128.910766,
        "city_lat": 47.734685,
        "city_g": "128.910766,47.734685|14",
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "city_name": "武汉",
        "city_lng": 114.3162,
        "city_lat": 30.581084,
        "city_g": "114.3162,30.581084|12",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "鄂州",
        "city_lng": 114.895594,
        "city_lat": 30.384439,
        "city_g": "114.895594,30.384439|14",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "恩施",
        "city_lng": 109.517433,
        "city_lat": 30.308978,
        "city_g": "109.517433,30.308978|14",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "黄冈",
        "city_lng": 114.906618,
        "city_lat": 30.446109,
        "city_g": "114.906618,30.446109|14",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "黄石",
        "city_lng": 115.050683,
        "city_lat": 30.216127,
        "city_g": "115.050683,30.216127|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "荆门",
        "city_lng": 112.21733,
        "city_lat": 31.042611,
        "city_g": "112.21733,31.042611|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "荆州",
        "city_lng": 112.241866,
        "city_lat": 30.332591,
        "city_g": "112.241866,30.332591|12",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "潜江",
        "city_lng": 112.768768,
        "city_lat": 30.343116,
        "city_g": "112.768768,30.343116|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "神农架林区",
        "city_lng": 110.487231,
        "city_lat": 31.595768,
        "city_g": "110.487231,31.595768|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "十堰",
        "city_lng": 110.801229,
        "city_lat": 32.636994,
        "city_g": "110.801229,32.636994|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "随州",
        "city_lng": 113.379358,
        "city_lat": 31.717858,
        "city_g": "113.379358,31.717858|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "天门",
        "city_lng": 113.12623,
        "city_lat": 30.649047,
        "city_g": "113.12623,30.649047|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "仙桃",
        "city_lng": 113.387448,
        "city_lat": 30.293966,
        "city_g": "113.387448,30.293966|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "咸宁",
        "city_lng": 114.300061,
        "city_lat": 29.880657,
        "city_g": "114.300061,29.880657|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "襄阳",
        "city_lng": 112.176326,
        "city_lat": 32.094934,
        "city_g": "112.176326,32.094934|12",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "孝感",
        "city_lng": 113.935734,
        "city_lat": 30.927955,
        "city_g": "113.935734,30.927955|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "宜昌",
        "city_lng": 111.310981,
        "city_lat": 30.732758,
        "city_g": "111.310981,30.732758|13",
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "city_name": "长沙",
        "city_lng": 112.979353,
        "city_lat": 28.213478,
        "city_g": "112.979353,28.213478|12",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "常德",
        "city_lng": 111.653718,
        "city_lat": 29.012149,
        "city_g": "111.653718,29.012149|12",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "郴州",
        "city_lng": 113.037704,
        "city_lat": 25.782264,
        "city_g": "113.037704,25.782264|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "衡阳",
        "city_lng": 112.583819,
        "city_lat": 26.898164,
        "city_g": "112.583819,26.898164|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "怀化",
        "city_lng": 109.986959,
        "city_lat": 27.557483,
        "city_g": "109.986959,27.557483|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "娄底",
        "city_lng": 111.996396,
        "city_lat": 27.741073,
        "city_g": "111.996396,27.741073|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "邵阳",
        "city_lng": 111.461525,
        "city_lat": 27.236811,
        "city_g": "111.461525,27.236811|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "湘潭",
        "city_lng": 112.935556,
        "city_lat": 27.835095,
        "city_g": "112.935556,27.835095|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "湘西州",
        "city_lng": 109.745746,
        "city_lat": 28.317951,
        "city_g": "109.745746,28.317951|14",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "益阳",
        "city_lng": 112.366547,
        "city_lat": 28.588088,
        "city_g": "112.366547,28.588088|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "永州",
        "city_lng": 111.614648,
        "city_lat": 26.435972,
        "city_g": "111.614648,26.435972|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "岳阳",
        "city_lng": 113.146196,
        "city_lat": 29.378007,
        "city_g": "113.146196,29.378007|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "张家界",
        "city_lng": 110.48162,
        "city_lat": 29.124889,
        "city_g": "110.48162,29.124889|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "株洲",
        "city_lng": 113.131695,
        "city_lat": 27.827433,
        "city_g": "113.131695,27.827433|13",
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "city_name": "南京",
        "city_lng": 118.778074,
        "city_lat": 32.057236,
        "city_g": "118.778074,32.057236|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "常州",
        "city_lng": 119.981861,
        "city_lat": 31.771397,
        "city_g": "119.981861,31.771397|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "淮安",
        "city_lng": 119.030186,
        "city_lat": 33.606513,
        "city_g": "119.030186,33.606513|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "连云港",
        "city_lng": 119.173872,
        "city_lat": 34.601549,
        "city_g": "119.173872,34.601549|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "南通",
        "city_lng": 120.873801,
        "city_lat": 32.014665,
        "city_g": "120.873801,32.014665|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "苏州",
        "city_lng": 120.619907,
        "city_lat": 31.317987,
        "city_g": "120.619907,31.317987|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "宿迁",
        "city_lng": 118.296893,
        "city_lat": 33.95205,
        "city_g": "118.296893,33.95205|13",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "泰州",
        "city_lng": 119.919606,
        "city_lat": 32.476053,
        "city_g": "119.919606,32.476053|13",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "无锡",
        "city_lng": 120.305456,
        "city_lat": 31.570037,
        "city_g": "120.305456,31.570037|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "徐州",
        "city_lng": 117.188107,
        "city_lat": 34.271553,
        "city_g": "117.188107,34.271553|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "盐城",
        "city_lng": 120.148872,
        "city_lat": 33.379862,
        "city_g": "120.148872,33.379862|12",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "扬州",
        "city_lng": 119.427778,
        "city_lat": 32.408505,
        "city_g": "119.427778,32.408505|13",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "镇江",
        "city_lng": 119.455835,
        "city_lat": 32.204409,
        "city_g": "119.455835,32.204409|13",
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "city_name": "南昌",
        "city_lng": 115.893528,
        "city_lat": 28.689578,
        "city_g": "115.893528,28.689578|12",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "抚州",
        "city_lng": 116.360919,
        "city_lat": 27.954545,
        "city_g": "116.360919,27.954545|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "赣州",
        "city_lng": 114.935909,
        "city_lat": 25.845296,
        "city_g": "114.935909,25.845296|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "吉安",
        "city_lng": 114.992039,
        "city_lat": 27.113848,
        "city_g": "114.992039,27.113848|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "景德镇",
        "city_lng": 117.186523,
        "city_lat": 29.303563,
        "city_g": "117.186523,29.303563|12",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "九江",
        "city_lng": 115.999848,
        "city_lat": 29.71964,
        "city_g": "115.999848,29.71964|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "萍乡",
        "city_lng": 113.859917,
        "city_lat": 27.639544,
        "city_g": "113.859917,27.639544|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "上饶",
        "city_lng": 117.955464,
        "city_lat": 28.457623,
        "city_g": "117.955464,28.457623|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "新余",
        "city_lng": 114.947117,
        "city_lat": 27.822322,
        "city_g": "114.947117,27.822322|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "宜春",
        "city_lng": 114.400039,
        "city_lat": 27.81113,
        "city_g": "114.400039,27.81113|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "鹰潭",
        "city_lng": 117.03545,
        "city_lat": 28.24131,
        "city_g": "117.03545,28.24131|13",
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "city_name": "长春",
        "city_lng": 125.313642,
        "city_lat": 43.898338,
        "city_g": "125.313642,43.898338|12",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "白城",
        "city_lng": 122.840777,
        "city_lat": 45.621086,
        "city_g": "122.840777,45.621086|13",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "白山",
        "city_lng": 126.435798,
        "city_lat": 41.945859,
        "city_g": "126.435798,41.945859|13",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "吉林市",
        "city_lng": 126.564544,
        "city_lat": 43.871988,
        "city_g": "126.564544,43.871988|12",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "辽源",
        "city_lng": 125.133686,
        "city_lat": 42.923303,
        "city_g": "125.133686,42.923303|13",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "四平",
        "city_lng": 124.391382,
        "city_lat": 43.175525,
        "city_g": "124.391382,43.175525|12",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "松原",
        "city_lng": 124.832995,
        "city_lat": 45.136049,
        "city_g": "124.832995,45.136049|13",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "通化",
        "city_lng": 125.94265,
        "city_lat": 41.736397,
        "city_g": "125.94265,41.736397|13",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "延边",
        "city_lng": 129.485902,
        "city_lat": 42.896414,
        "city_g": "129.485902,42.896414|13",
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "city_name": "沈阳",
        "city_lng": 123.432791,
        "city_lat": 41.808645,
        "city_g": "123.432791,41.808645|12",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "鞍山",
        "city_lng": 123.007763,
        "city_lat": 41.118744,
        "city_g": "123.007763,41.118744|13",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "本溪",
        "city_lng": 123.778062,
        "city_lat": 41.325838,
        "city_g": "123.778062,41.325838|12",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "朝阳",
        "city_lng": 120.446163,
        "city_lat": 41.571828,
        "city_g": "120.446163,41.571828|13",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "大连",
        "city_lng": 121.593478,
        "city_lat": 38.94871,
        "city_g": "121.593478,38.94871|12",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "丹东",
        "city_lng": 124.338543,
        "city_lat": 40.129023,
        "city_g": "124.338543,40.129023|12",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "抚顺",
        "city_lng": 123.92982,
        "city_lat": 41.877304,
        "city_g": "123.92982,41.877304|12",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "阜新",
        "city_lng": 121.660822,
        "city_lat": 42.01925,
        "city_g": "121.660822,42.01925|14",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "葫芦岛",
        "city_lng": 120.860758,
        "city_lat": 40.74303,
        "city_g": "120.860758,40.74303|13",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "锦州",
        "city_lng": 121.147749,
        "city_lat": 41.130879,
        "city_g": "121.147749,41.130879|13",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "辽阳",
        "city_lng": 123.172451,
        "city_lat": 41.273339,
        "city_g": "123.172451,41.273339|14",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "盘锦",
        "city_lng": 122.073228,
        "city_lat": 41.141248,
        "city_g": "122.073228,41.141248|13",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "铁岭",
        "city_lng": 123.85485,
        "city_lat": 42.299757,
        "city_g": "123.85485,42.299757|13",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "营口",
        "city_lng": 122.233391,
        "city_lat": 40.668651,
        "city_g": "122.233391,40.668651|13",
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "city_name": "呼和浩特",
        "city_lng": 111.660351,
        "city_lat": 40.828319,
        "city_g": "111.660351,40.828319|12",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "阿拉善盟",
        "city_lng": 105.695683,
        "city_lat": 38.843075,
        "city_g": "105.695683,38.843075|14",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "包头",
        "city_lng": 109.846239,
        "city_lat": 40.647119,
        "city_g": "109.846239,40.647119|12",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "巴彦淖尔",
        "city_lng": 107.423807,
        "city_lat": 40.76918,
        "city_g": "107.423807,40.76918|12",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "赤峰",
        "city_lng": 118.930761,
        "city_lat": 42.297112,
        "city_g": "118.930761,42.297112|12",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "鄂尔多斯",
        "city_lng": 109.993706,
        "city_lat": 39.81649,
        "city_g": "109.993706,39.81649|12",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "呼伦贝尔",
        "city_lng": 119.760822,
        "city_lat": 49.201636,
        "city_g": "119.760822,49.201636|12",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "通辽",
        "city_lng": 122.260363,
        "city_lat": 43.633756,
        "city_g": "122.260363,43.633756|12",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "乌海",
        "city_lng": 106.831999,
        "city_lat": 39.683177,
        "city_g": "106.831999,39.683177|13",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "乌兰察布",
        "city_lng": 113.112846,
        "city_lat": 41.022363,
        "city_g": "113.112846,41.022363|12",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "锡林郭勒盟",
        "city_lng": 116.02734,
        "city_lat": 43.939705,
        "city_g": "116.02734,43.939705|11",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "兴安盟",
        "city_lng": 122.048167,
        "city_lat": 46.083757,
        "city_g": "122.048167,46.083757|11",
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "city_name": "银川",
        "city_lng": 106.206479,
        "city_lat": 38.502621,
        "city_g": "106.206479,38.502621|12",
        "province_name": "宁夏",
        "province_lng": 106.155481,
        "province_lat": 37.321323,
        "province_g": "106.155481,37.321323|8"
    },
    {
        "city_name": "固原",
        "city_lng": 106.285268,
        "city_lat": 36.021523,
        "city_g": "106.285268,36.021523|13",
        "province_name": "宁夏",
        "province_lng": 106.155481,
        "province_lat": 37.321323,
        "province_g": "106.155481,37.321323|8"
    },
    {
        "city_name": "石嘴山",
        "city_lng": 106.379337,
        "city_lat": 39.020223,
        "city_g": "106.379337,39.020223|13",
        "province_name": "宁夏",
        "province_lng": 106.155481,
        "province_lat": 37.321323,
        "province_g": "106.155481,37.321323|8"
    },
    {
        "city_name": "吴忠",
        "city_lng": 106.208254,
        "city_lat": 37.993561,
        "city_g": "106.208254,37.993561|14",
        "province_name": "宁夏",
        "province_lng": 106.155481,
        "province_lat": 37.321323,
        "province_g": "106.155481,37.321323|8"
    },
    {
        "city_name": "中卫",
        "city_lng": 105.196754,
        "city_lat": 37.521124,
        "city_g": "105.196754,37.521124|14",
        "province_name": "宁夏",
        "province_lng": 106.155481,
        "province_lat": 37.321323,
        "province_g": "106.155481,37.321323|8"
    },
    {
        "city_name": "西宁",
        "city_lng": 101.767921,
        "city_lat": 36.640739,
        "city_g": "101.767921,36.640739|12",
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "city_name": "果洛州",
        "city_lng": 100.223723,
        "city_lat": 34.480485,
        "city_g": "100.223723,34.480485|11",
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "city_name": "海东地区",
        "city_lng": 102.085207,
        "city_lat": 36.51761,
        "city_g": "102.085207,36.51761|11",
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "city_name": "海北州",
        "city_lng": 100.879802,
        "city_lat": 36.960654,
        "city_g": "100.879802,36.960654|11",
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "city_name": "海南州",
        "city_lng": 100.624066,
        "city_lat": 36.284364,
        "city_g": "100.624066,36.284364|11",
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "city_name": "海西州",
        "city_lng": 97.342625,
        "city_lat": 37.373799,
        "city_g": "97.342625,37.373799|11",
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "city_name": "黄南州",
        "city_lng": 102.0076,
        "city_lat": 35.522852,
        "city_g": "102.0076,35.522852|11",
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "city_name": "玉树州",
        "city_lng": 97.013316,
        "city_lat": 33.00624,
        "city_g": "97.013316,33.00624|14",
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "city_name": "济南",
        "city_lng": 117.024967,
        "city_lat": 36.682785,
        "city_g": "117.024967,36.682785|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "滨州",
        "city_lng": 117.968292,
        "city_lat": 37.405314,
        "city_g": "117.968292,37.405314|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "东营",
        "city_lng": 118.583926,
        "city_lat": 37.487121,
        "city_g": "118.583926,37.487121|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "德州",
        "city_lng": 116.328161,
        "city_lat": 37.460826,
        "city_g": "116.328161,37.460826|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "菏泽",
        "city_lng": 115.46336,
        "city_lat": 35.26244,
        "city_g": "115.46336,35.26244|13",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "济宁",
        "city_lng": 116.600798,
        "city_lat": 35.402122,
        "city_g": "116.600798,35.402122|13",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "莱芜",
        "city_lng": 117.684667,
        "city_lat": 36.233654,
        "city_g": "117.684667,36.233654|13",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "聊城",
        "city_lng": 115.986869,
        "city_lat": 36.455829,
        "city_g": "115.986869,36.455829|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "临沂",
        "city_lng": 118.340768,
        "city_lat": 35.072409,
        "city_g": "118.340768,35.072409|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "青岛",
        "city_lng": 120.384428,
        "city_lat": 36.105215,
        "city_g": "120.384428,36.105215|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "日照",
        "city_lng": 119.50718,
        "city_lat": 35.420225,
        "city_g": "119.50718,35.420225|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "泰安",
        "city_lng": 117.089415,
        "city_lat": 36.188078,
        "city_g": "117.089415,36.188078|13",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "威海",
        "city_lng": 122.093958,
        "city_lat": 37.528787,
        "city_g": "122.093958,37.528787|13",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "潍坊",
        "city_lng": 119.142634,
        "city_lat": 36.716115,
        "city_g": "119.142634,36.716115|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "烟台",
        "city_lng": 121.309555,
        "city_lat": 37.536562,
        "city_g": "121.309555,37.536562|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "枣庄",
        "city_lng": 117.279305,
        "city_lat": 34.807883,
        "city_g": "117.279305,34.807883|13",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "淄博",
        "city_lng": 118.059134,
        "city_lat": 36.804685,
        "city_g": "118.059134,36.804685|12",
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "city_name": "太原",
        "city_lng": 112.550864,
        "city_lat": 37.890277,
        "city_g": "112.550864,37.890277|12",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "长治",
        "city_lng": 113.120292,
        "city_lat": 36.201664,
        "city_g": "113.120292,36.201664|12",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "大同",
        "city_lng": 113.290509,
        "city_lat": 40.113744,
        "city_g": "113.290509,40.113744|12",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "晋城",
        "city_lng": 112.867333,
        "city_lat": 35.499834,
        "city_g": "112.867333,35.499834|13",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "晋中",
        "city_lng": 112.738514,
        "city_lat": 37.693362,
        "city_g": "112.738514,37.693362|13",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "临汾",
        "city_lng": 111.538788,
        "city_lat": 36.099745,
        "city_g": "111.538788,36.099745|13",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "吕梁",
        "city_lng": 111.143157,
        "city_lat": 37.527316,
        "city_g": "111.143157,37.527316|14",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "朔州",
        "city_lng": 112.479928,
        "city_lat": 39.337672,
        "city_g": "112.479928,39.337672|13",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "忻州",
        "city_lng": 112.727939,
        "city_lat": 38.461031,
        "city_g": "112.727939,38.461031|12",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "阳泉",
        "city_lng": 113.569238,
        "city_lat": 37.869529,
        "city_g": "113.569238,37.869529|13",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "运城",
        "city_lng": 111.006854,
        "city_lat": 35.038859,
        "city_g": "111.006854,35.038859|13",
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "city_name": "西安",
        "city_lng": 108.953098,
        "city_lat": 34.2778,
        "city_g": "108.953098,34.2778|12",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "安康",
        "city_lng": 109.038045,
        "city_lat": 32.70437,
        "city_g": "109.038045,32.70437|13",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "宝鸡",
        "city_lng": 107.170645,
        "city_lat": 34.364081,
        "city_g": "107.170645,34.364081|12",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "汉中",
        "city_lng": 107.045478,
        "city_lat": 33.081569,
        "city_g": "107.045478,33.081569|13",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "商洛",
        "city_lng": 109.934208,
        "city_lat": 33.873907,
        "city_g": "109.934208,33.873907|13",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "铜川",
        "city_lng": 108.968067,
        "city_lat": 34.908368,
        "city_g": "108.968067,34.908368|13",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "渭南",
        "city_lng": 109.483933,
        "city_lat": 34.502358,
        "city_g": "109.483933,34.502358|13",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "咸阳",
        "city_lng": 108.707509,
        "city_lat": 34.345373,
        "city_g": "108.707509,34.345373|13",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "延安",
        "city_lng": 109.50051,
        "city_lat": 36.60332,
        "city_g": "109.50051,36.60332|13",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "榆林",
        "city_lng": 109.745926,
        "city_lat": 38.279439,
        "city_g": "109.745926,38.279439|12",
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "city_name": "成都",
        "city_lng": 104.067923,
        "city_lat": 30.679943,
        "city_g": "104.067923,30.679943|12",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "阿坝州",
        "city_lng": 102.228565,
        "city_lat": 31.905763,
        "city_g": "102.228565,31.905763|15",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "巴中",
        "city_lng": 106.757916,
        "city_lat": 31.869189,
        "city_g": "106.757916,31.869189|14",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "达州",
        "city_lng": 107.494973,
        "city_lat": 31.214199,
        "city_g": "107.494973,31.214199|14",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "德阳",
        "city_lng": 104.402398,
        "city_lat": 31.13114,
        "city_g": "104.402398,31.13114|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "甘孜州",
        "city_lng": 101.969232,
        "city_lat": 30.055144,
        "city_g": "101.969232,30.055144|15",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "广安",
        "city_lng": 106.63572,
        "city_lat": 30.463984,
        "city_g": "106.63572,30.463984|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "广元",
        "city_lng": 105.819687,
        "city_lat": 32.44104,
        "city_g": "105.819687,32.44104|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "乐山",
        "city_lng": 103.760824,
        "city_lat": 29.600958,
        "city_g": "103.760824,29.600958|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "凉山州",
        "city_lng": 102.259591,
        "city_lat": 27.892393,
        "city_g": "102.259591,27.892393|14",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "泸州",
        "city_lng": 105.44397,
        "city_lat": 28.89593,
        "city_g": "105.44397,28.89593|14",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "南充",
        "city_lng": 106.105554,
        "city_lat": 30.800965,
        "city_g": "106.105554,30.800965|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "眉山",
        "city_lng": 103.84143,
        "city_lat": 30.061115,
        "city_g": "103.84143,30.061115|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "绵阳",
        "city_lng": 104.705519,
        "city_lat": 31.504701,
        "city_g": "104.705519,31.504701|12",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "内江",
        "city_lng": 105.073056,
        "city_lat": 29.599462,
        "city_g": "105.073056,29.599462|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "攀枝花",
        "city_lng": 101.722423,
        "city_lat": 26.587571,
        "city_g": "101.722423,26.587571|14",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "遂宁",
        "city_lng": 105.564888,
        "city_lat": 30.557491,
        "city_g": "105.564888,30.557491|12",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "雅安",
        "city_lng": 103.009356,
        "city_lat": 29.999716,
        "city_g": "103.009356,29.999716|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "宜宾",
        "city_lng": 104.633019,
        "city_lat": 28.769675,
        "city_g": "104.633019,28.769675|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "资阳",
        "city_lng": 104.63593,
        "city_lat": 30.132191,
        "city_g": "104.63593,30.132191|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "自贡",
        "city_lng": 104.776071,
        "city_lat": 29.359157,
        "city_g": "104.776071,29.359157|13",
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "city_name": "拉萨",
        "city_lng": 91.111891,
        "city_lat": 29.662557,
        "city_g": "91.111891,29.662557|13",
        "province_name": "西藏",
        "province_lng": 89.137982,
        "province_lat": 31.367315,
        "province_g": "89.137982,31.367315|6"
    },
    {
        "city_name": "阿里地区",
        "city_lng": 81.107669,
        "city_lat": 30.404557,
        "city_g": "81.107669,30.404557|11",
        "province_name": "西藏",
        "province_lng": 89.137982,
        "province_lat": 31.367315,
        "province_g": "89.137982,31.367315|6"
    },
    {
        "city_name": "昌都地区",
        "city_lng": 97.185582,
        "city_lat": 31.140576,
        "city_g": "97.185582,31.140576|15",
        "province_name": "西藏",
        "province_lng": 89.137982,
        "province_lat": 31.367315,
        "province_g": "89.137982,31.367315|6"
    },
    {
        "city_name": "林芝地区",
        "city_lng": 94.349985,
        "city_lat": 29.666941,
        "city_g": "94.349985,29.666941|11",
        "province_name": "西藏",
        "province_lng": 89.137982,
        "province_lat": 31.367315,
        "province_g": "89.137982,31.367315|6"
    },
    {
        "city_name": "那曲地区",
        "city_lng": 92.067018,
        "city_lat": 31.48068,
        "city_g": "92.067018,31.48068|14",
        "province_name": "西藏",
        "province_lng": 89.137982,
        "province_lat": 31.367315,
        "province_g": "89.137982,31.367315|6"
    },
    {
        "city_name": "日喀则地区",
        "city_lng": 88.891486,
        "city_lat": 29.269023,
        "city_g": "88.891486,29.269023|14",
        "province_name": "西藏",
        "province_lng": 89.137982,
        "province_lat": 31.367315,
        "province_g": "89.137982,31.367315|6"
    },
    {
        "city_name": "山南地区",
        "city_lng": 91.750644,
        "city_lat": 29.229027,
        "city_g": "91.750644,29.229027|11",
        "province_name": "西藏",
        "province_lng": 89.137982,
        "province_lat": 31.367315,
        "province_g": "89.137982,31.367315|6"
    },
    {
        "city_name": "乌鲁木齐",
        "city_lng": 87.564988,
        "city_lat": 43.84038,
        "city_g": "87.564988,43.84038|12",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "阿拉尔",
        "city_lng": 81.291737,
        "city_lat": 40.61568,
        "city_g": "81.291737,40.61568|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "阿克苏地区",
        "city_lng": 80.269846,
        "city_lat": 41.171731,
        "city_g": "80.269846,41.171731|12",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "阿勒泰地区",
        "city_lng": 88.137915,
        "city_lat": 47.839744,
        "city_g": "88.137915,47.839744|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "巴音郭楞",
        "city_lng": 86.121688,
        "city_lat": 41.771362,
        "city_g": "86.121688,41.771362|12",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "博尔塔拉州",
        "city_lng": 82.052436,
        "city_lat": 44.913651,
        "city_g": "82.052436,44.913651|11",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "昌吉州",
        "city_lng": 87.296038,
        "city_lat": 44.007058,
        "city_g": "87.296038,44.007058|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "哈密地区",
        "city_lng": 93.528355,
        "city_lat": 42.858596,
        "city_g": "93.528355,42.858596|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "和田地区",
        "city_lng": 79.930239,
        "city_lat": 37.116774,
        "city_g": "79.930239,37.116774|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "喀什地区",
        "city_lng": 75.992973,
        "city_lat": 39.470627,
        "city_g": "75.992973,39.470627|12",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "克拉玛依",
        "city_lng": 84.88118,
        "city_lat": 45.594331,
        "city_g": "84.88118,45.594331|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "克孜勒苏州",
        "city_lng": 76.137564,
        "city_lat": 39.750346,
        "city_g": "76.137564,39.750346|11",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "石河子",
        "city_lng": 86.041865,
        "city_lat": 44.308259,
        "city_g": "86.041865,44.308259|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "塔城地区",
        "city_lng": 82.974881,
        "city_lat": 46.758684,
        "city_g": "82.974881,46.758684|12",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "图木舒克",
        "city_lng": 79.198155,
        "city_lat": 39.889223,
        "city_g": "79.198155,39.889223|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "吐鲁番地区",
        "city_lng": 89.181595,
        "city_lat": 42.96047,
        "city_g": "89.181595,42.96047|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "五家渠",
        "city_lng": 87.565449,
        "city_lat": 44.368899,
        "city_g": "87.565449,44.368899|13",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "伊犁州",
        "city_lng": 81.297854,
        "city_lat": 43.922248,
        "city_g": "81.297854,43.922248|11",
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "city_name": "昆明",
        "city_lng": 102.714601,
        "city_lat": 25.049153,
        "city_g": "102.714601,25.049153|12",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "保山",
        "city_lng": 99.177996,
        "city_lat": 25.120489,
        "city_g": "99.177996,25.120489|13",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "楚雄州",
        "city_lng": 101.529382,
        "city_lat": 25.066356,
        "city_g": "101.529382,25.066356|13",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "大理州",
        "city_lng": 100.223675,
        "city_lat": 25.5969,
        "city_g": "100.223675,25.5969|14",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "德宏州",
        "city_lng": 98.589434,
        "city_lat": 24.44124,
        "city_g": "98.589434,24.44124|14",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "迪庆州",
        "city_lng": 99.713682,
        "city_lat": 27.831029,
        "city_g": "99.713682,27.831029|14",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "红河州",
        "city_lng": 103.384065,
        "city_lat": 23.367718,
        "city_g": "103.384065,23.367718|11",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "丽江",
        "city_lng": 100.229628,
        "city_lat": 26.875351,
        "city_g": "100.229628,26.875351|13",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "临沧",
        "city_lng": 100.092613,
        "city_lat": 23.887806,
        "city_g": "100.092613,23.887806|14",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "怒江州",
        "city_lng": 98.859932,
        "city_lat": 25.860677,
        "city_g": "98.859932,25.860677|14",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "普洱",
        "city_lng": 100.980058,
        "city_lat": 22.788778,
        "city_g": "100.980058,22.788778|14",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "曲靖",
        "city_lng": 103.782539,
        "city_lat": 25.520758,
        "city_g": "103.782539,25.520758|12",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "昭通",
        "city_lng": 103.725021,
        "city_lat": 27.340633,
        "city_g": "103.725021,27.340633|13",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "文山",
        "city_lng": 104.089112,
        "city_lat": 23.401781,
        "city_g": "104.089112,23.401781|14",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "西双版纳",
        "city_lng": 100.803038,
        "city_lat": 22.009433,
        "city_g": "100.803038,22.009433|13",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "玉溪",
        "city_lng": 102.545068,
        "city_lat": 24.370447,
        "city_g": "102.545068,24.370447|13",
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "city_name": "杭州",
        "city_lng": 120.219375,
        "city_lat": 30.259244,
        "city_g": "120.219375,30.259244|12",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "湖州",
        "city_lng": 120.137243,
        "city_lat": 30.877925,
        "city_g": "120.137243,30.877925|12",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "嘉兴",
        "city_lng": 120.760428,
        "city_lat": 30.773992,
        "city_g": "120.760428,30.773992|13",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "金华",
        "city_lng": 119.652576,
        "city_lat": 29.102899,
        "city_g": "119.652576,29.102899|12",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "丽水",
        "city_lng": 119.929576,
        "city_lat": 28.4563,
        "city_g": "119.929576,28.4563|13",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "宁波",
        "city_lng": 121.579006,
        "city_lat": 29.885259,
        "city_g": "121.579006,29.885259|12",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "衢州",
        "city_lng": 118.875842,
        "city_lat": 28.95691,
        "city_g": "118.875842,28.95691|12",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "绍兴",
        "city_lng": 120.592467,
        "city_lat": 30.002365,
        "city_g": "120.592467,30.002365|13",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "台州",
        "city_lng": 121.440613,
        "city_lat": 28.668283,
        "city_g": "121.440613,28.668283|13",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "温州",
        "city_lng": 120.690635,
        "city_lat": 28.002838,
        "city_g": "120.690635,28.002838|12",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    },
    {
        "city_name": "舟山",
        "city_lng": 122.169872,
        "city_lat": 30.03601,
        "city_g": "122.169872,30.03601|13",
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    }
]

export let provincrList = [
    {
        "province_name": "北京",
        "province_lng": 116.395645,
        "province_lat": 39.929986,
        "province_g": "116.395645,39.929986|12"
    },
    {
        "province_name": "上海",
        "province_lng": 121.487899,
        "province_lat": 31.249162,
        "province_g": "121.487899,31.249162|12"
    },
    {
        "province_name": "天津",
        "province_lng": 117.210813,
        "province_lat": 39.14393,
        "province_g": "117.210813,39.14393|12"
    },
    {
        "province_name": "重庆",
        "province_lng": 106.530635,
        "province_lat": 29.544606,
        "province_g": "106.530635,29.544606|12"
    },
    {
        "province_name": "香港",
        "province_lng": 114.186124,
        "province_lat": 22.293586,
        "province_g": "114.186124,22.293586|11"
    },
    {
        "province_name": "澳门",
        "province_lng": 113.557519,
        "province_lat": 22.204118,
        "province_g": "113.557519,22.204118|13"
    },
    {
        "province_name": "台湾",
        "province_lng": 120.961454,
        "province_lat": 23.80406,
        "province_g": "120.961454,23.80406|8"
    },
    {
        "province_name": "安徽",
        "province_lng": 117.216005,
        "province_lat": 31.859252,
        "province_g": "117.216005,31.859252|8"
    },
    {
        "province_name": "福建",
        "province_lng": 117.984943,
        "province_lat": 26.050118,
        "province_g": "117.984943,26.050118|8"
    },
    {
        "province_name": "甘肃",
        "province_lng": 102.457625,
        "province_lat": 38.103267,
        "province_g": "102.457625,38.103267|6"
    },
    {
        "province_name": "广东",
        "province_lng": 113.394818,
        "province_lat": 23.408004,
        "province_g": "113.394818,23.408004|8"
    },
    {
        "province_name": "广西",
        "province_lng": 108.924274,
        "province_lat": 23.552255,
        "province_g": "108.924274,23.552255|7"
    },
    {
        "province_name": "贵州",
        "province_lng": 106.734996,
        "province_lat": 26.902826,
        "province_g": "106.734996,26.902826|8"
    },
    {
        "province_name": "海南",
        "province_lng": 109.733755,
        "province_lat": 19.180501,
        "province_g": "109.733755,19.180501|9"
    },
    {
        "province_name": "河北",
        "province_lng": 115.661434,
        "province_lat": 38.61384,
        "province_g": "115.661434,38.61384|7"
    },
    {
        "province_name": "河南",
        "province_lng": 113.486804,
        "province_lat": 34.157184,
        "province_g": "113.486804,34.157184|7"
    },
    {
        "province_name": "黑龙江",
        "province_lng": 128.047414,
        "province_lat": 47.356592,
        "province_g": "128.047414,47.356592|6"
    },
    {
        "province_name": "湖北",
        "province_lng": 112.410562,
        "province_lat": 31.209316,
        "province_g": "112.410562,31.209316|8"
    },
    {
        "province_name": "湖南",
        "province_lng": 111.720664,
        "province_lat": 27.695864,
        "province_g": "111.720664,27.695864|7"
    },
    {
        "province_name": "江苏",
        "province_lng": 119.368489,
        "province_lat": 33.013797,
        "province_g": "119.368489,33.013797|8"
    },
    {
        "province_name": "江西",
        "province_lng": 115.676082,
        "province_lat": 27.757258,
        "province_g": "115.676082,27.757258|7"
    },
    {
        "province_name": "吉林",
        "province_lng": 126.262876,
        "province_lat": 43.678846,
        "province_g": "126.262876,43.678846|7"
    },
    {
        "province_name": "辽宁",
        "province_lng": 122.753592,
        "province_lat": 41.6216,
        "province_g": "122.753592,41.6216|8"
    },
    {
        "province_name": "内蒙古",
        "province_lng": 114.415868,
        "province_lat": 43.468238,
        "province_g": "114.415868,43.468238|5"
    },
    {
        "province_name": "宁夏",
        "province_lng": 106.155481,
        "province_lat": 37.321323,
        "province_g": "106.155481,37.321323|8"
    },
    {
        "province_name": "青海",
        "province_lng": 96.202544,
        "province_lat": 35.499761,
        "province_g": "96.202544,35.499761|7"
    },
    {
        "province_name": "山东",
        "province_lng": 118.527663,
        "province_lat": 36.09929,
        "province_g": "118.527663,36.09929|8"
    },
    {
        "province_name": "山西",
        "province_lng": 112.515496,
        "province_lat": 37.866566,
        "province_g": "112.515496,37.866566|7"
    },
    {
        "province_name": "陕西",
        "province_lng": 109.503789,
        "province_lat": 35.860026,
        "province_g": "109.503789,35.860026|7"
    },
    {
        "province_name": "四川",
        "province_lng": 102.89916,
        "province_lat": 30.367481,
        "province_g": "102.89916,30.367481|7"
    },
    {
        "province_name": "西藏",
        "province_lng": 89.137982,
        "province_lat": 31.367315,
        "province_g": "89.137982,31.367315|6"
    },
    {
        "province_name": "新疆",
        "province_lng": 85.614899,
        "province_lat": 42.127001,
        "province_g": "85.614899,42.127001|6"
    },
    {
        "province_name": "云南",
        "province_lng": 101.592952,
        "province_lat": 24.864213,
        "province_g": "101.592952,24.864213|7"
    },
    {
        "province_name": "浙江",
        "province_lng": 119.957202,
        "province_lat": 29.159494,
        "province_g": "119.957202,29.159494|8"
    }
]